<template>

<div class="main" id="detail-4473-legacy">
	<div v-if="form.form_data.customerValues && !nicsOnlineCheck">

		<div class="form">

			<div style="position: absolute; top: 1.25em">
				<input type="text" v-model="form.form_number" placeholder="Transaction Serial Number" style="width: 15em;">
				<div class="button primary" style="font-size: 0.75em; height: 2em; padding: 0.5em 0.75em 0 0.75em;" @click="saveFormNumber()">Save</div>
				<span class="message">{{ formNumberMessage }}</span>
			</div>

			<div class="controls section-top">
				<a class="primary button" :href="generatePDFLink()" target="_blank">Print</a>
				<router-link to="/logbooks/4473" tag="div" class="primary button"><i class="fa fa-arrow-circle-left"></i> Back To List</router-link>
			</div>

			<h2 class="section-title">Section A</h2>
			<div class="form-line grid-four">
				<div class="form-full light-font">
					1. Transferee/Buyer's Full Name
				</div>

				<div class="form-quarter">
					<div class="dark-font">Last Name</div>
					<div>
						{{ form.form_data.last_name }} {{ form.form_data.suffix }}
						&nbsp;<span class="initial-only" v-if="form.form_data.last_initial">IO</span>
						<span class="cadence-code" v-if="form.form_data.cadence_code">{{ form.form_data.cadence_code }}</span>
					</div>
				</div>

				<div class="form-quarter">
					<div class="dark-font">First Name</div>
					<div>{{ form.form_data.first_name }} <span class="initial-only" v-if="form.form_data.first_initial">IO</span></div>
				</div>

				<div class="form-quarter">
					<div class="dark-font">Middle Name</div>
					<div v-if="!form.form_data.middle_name_blank">{{ form.form_data.middle_name }} <span class="initial-only" v-if="form.form_data.middle_initial">IO</span></div>
					<div v-else>NMN</div>
				</div>
			</div>

			<div class="form-line grid-four">
				<div class="form-full light-font">
					2. Current State of Residence and Address
				</div>

				<div class="form-quarter">
					<div class="dark-font">Number and Street Address</div>
					<div>{{ form.form_data.address_1 }}</div>
					<div class="home-address" v-if="form.form_data.home_address_1">{{ form.form_data.home_address_1 }}</div>
				</div>

				<div class="form-quarter">
					<div class="dark-font">City</div>
					<div>{{ form.form_data.city }}</div>
					<div class="home-address" v-if="form.form_data.home_city">{{ form.form_data.home_city }}</div>
				</div>

				<div class="form-quarter">
					<div class="dark-font">County</div>
					<div>{{ form.form_data.county }}</div>
					<div class="home-address" v-if="form.form_data.home_county">{{ form.form_data.home_county }}</div>
				</div>

				<div class="form-quarter">
					<div class="dark-font">State</div>
					<div>{{ form.form_data.state }}</div>
					<div class="home-address" v-if="form.form_data.home_state">{{ form.form_data.home_state }}</div>
				</div>

				<div class="form-quarter">
					<div class="dark-font">Zip Code</div>
					<div>{{ form.form_data.zip_code }}</div>
					<div class="home-address" v-if="form.form_data.home_zip_code">{{ form.form_data.home_zip_code }}</div>
				</div>
			</div>

			<div class="form-line grid-five">
				<p class="light-font">3. Place of Birth</p>
				<p class="light-font">4. Height</p>
				<p class="light-font">5. Weight</p>
				<p class="light-font">6. Sex</p>
				<p class="light-font">7. Birth Date</p>

				<div class="line-break" v-if="form.form_data.customerValues.POB_CODE">
					<template v-if="form.form_data.birth_city">
						<div class="dark-font">U.S. City and State</div>
						<div>{{ form.form_data.birth_city }}, {{ form.form_data.customerValues.POB_CODE }}</div>
					</template>
					<template v-else>
						<div class="dark-font">Foreign Country</div>
						<div>{{ form.form_data.customerValues.POB_CODE }}</div>
					</template>
				</div>
				<div class="line-break" v-else>N/A</div>

				<div class="form-quarter">
					<span class="light-font">Ft.</span>
					<span>{{ form.form_data.feet }}</span>
					<span class="light-font">In.</span>
					<span>{{ form.form_data.inches }}</span>
				</div>

				<div class="form-quarter">
					<span class="light-font">Lbs.</span>
					<div>{{ form.form_data.customerValues.WEIGHT }}</div>
				</div>

				<div class="form-quarter">
					<div class="light-font" v-if="form.form_data.customerValues.GENDER_CODE == 'M'">Male</div>
					<div class="light-font" v-if="form.form_data.customerValues.GENDER_CODE == 'F'">Female</div>
				</div>

				<div class="form-quarter">
					<div>{{ $moment(form.form_data.birthdate).format('MM/DD/YYYY') }}</div>
				</div>
			</div>

			<div class="form-line">
				<div class="form-half light-font">
					<div class="light-font">8. Social Security Number (Optional, but will help prevent misidentification)</div>
					<div>{{ form.form_data.customerValues.SSN }}</div>
				</div>

				<div class="form-half">
					<div class="light-font">9. Unique Personal Identification Number (UPIN) if applicable</div>
					<div>{{ form.form_data.customerValues.UPIN }}</div>
				</div>
			</div>

			<div class="form-line">
				<div class="span-1">
					<div class="light-font">10.a. Ethnicity</div>
					<div><i class="far fa-check-square" v-if="form.form_data.ethnicity == 'hispanic'"></i><i class="far fa-square" v-else></i>Hispanic or Latino</div>
					<div><i class="far fa-check-square" v-if="form.form_data.ethnicity == 'nonhispanic'"></i><i class="far fa-square" v-else></i>Not Hispanic or Latino</div>
				</div>

				<div id="race" class="form-threequarter">
					<div class="light-font">10.b. Race</div>
					<div class="checkbox"><i class="far fa-check-square" v-if="form.form_data.customerRace.l4"></i><i class="far fa-square" v-else></i>American Indian or Alaskan Native</div>
					<div class="checkbox"><i class="far fa-check-square" v-if="form.form_data.customerRace.l2"></i><i class="far fa-square" v-else></i>Black or African American</div>
					<div class="checkbox"><i class="far fa-check-square" v-if="form.form_data.customerRace.l6"></i><i class="far fa-square" v-else></i>White</div>
					<br>
					<div class="checkbox"><i class="far fa-check-square" v-if="form.form_data.customerRace.l1"></i><i class="far fa-square" v-else></i>Asian</div>
					<div class="checkbox"><i class="far fa-check-square" v-if="form.form_data.customerRace.l5"></i><i class="far fa-square" v-else></i>Native Hawaiian or Other Pacific Islander</div>
				</div>
			</div>

			<table cellpadding="0" cellspacing="0">
				<tr>
					<th class="light-font">11. Answer each of the following questions by checking or marking "yes" or "no".</th>
					<th>Yes</th>
					<th>No</th>
				</tr>
				<tr>
					<td>a. Are you the actual transferee/buyer of the firearm(s) listed on this form? Warning: You are not the actual transferee/buyer if you are acquiring the firearm(s) on behalf of another person. If you are not the actual transferee/buyer, the licensee cannot transfer the firearm(s) to you. Exception: If you are picking up a repaired firearm(s) for another person, you are not required to answer 11.a. and may proceed to question 11.b.</td>
					<td><i class="far fa-check-square" v-if="form.form_data.actual_buyer == 'yes'"></i><i class="far fa-square" v-else></i></td>
					<td><i class="far fa-check-square" v-if="form.form_data.actual_buyer == 'no'"></i><i class="far fa-square" v-else></i></td>
				</tr>
				<tr>
					<td>b. Are you under indictment or information in any court for a felony, or any other crime for which the judge could imprison you for more than one year?</td>
					<td><i class="far fa-check-square" v-if="form.form_data.under_indictment == 'yes'"></i><i class="far fa-square" v-else></i></td>
					<td><i class="far fa-check-square" v-if="form.form_data.under_indictment == 'no'"></i><i class="far fa-square" v-else></i></td>
				</tr>
				<tr>
					<td>c. Have you ever been convicted in any court of a felony, or any other crime for which the judge could have imprisoned you for more than one year, even if you received a shorter sentence including probation?</td>
					<td><i class="far fa-check-square" v-if="form.form_data.convict == 'yes'"></i><i class="far fa-square" v-else></i></td>
					<td><i class="far fa-check-square" v-if="form.form_data.convict == 'no'"></i><i class="far fa-square" v-else></i></td>
				</tr>
				<tr>
					<td>d. Are you a fugitive from justice?</td>
					<td><i class="far fa-check-square" v-if="form.form_data.fugitive == 'yes'"></i><i class="far fa-square" v-else></i></td>
					<td><i class="far fa-check-square" v-if="form.form_data.fugitive == 'no'"></i><i class="far fa-square" v-else></i></td>
				</tr>
				<tr>
					<td>e. Are you an unlawful user of, or addicted to, marijuana or any depressant, stimulant, narcotic drug, or any other controlled substance? <i>Warning: The use or possession of marijuana remains unlawful under Federal law regardless of whether it has been legalized or decriminalized for medicinal or recreational purposes in the state where you reside.</i></td>
					<td><i class="far fa-check-square" v-if="form.form_data.addict == 'yes'"></i><i class="far fa-square" v-else></i></td>
					<td><i class="far fa-check-square" v-if="form.form_data.addict == 'no'"></i><i class="far fa-square" v-else></i></td>
				</tr>
				<tr>
					<td>f. Have you ever been adjudicated as a mental defective OR have you ever been committed to a mental institution?</td>
					<td><i class="far fa-check-square" v-if="form.form_data.mental == 'yes'"></i><i class="far fa-square" v-else></i></td>
					<td><i class="far fa-check-square" v-if="form.form_data.mental == 'no'"></i><i class="far fa-square" v-else></i></td>
				</tr>
				<tr>
					<td>g. Have you been discharged from the Armed Forces under <i>dishonorable</i> conditions?</td>
					<td><i class="far fa-check-square" v-if="form.form_data.dishonorable_discharge == 'yes'"></i><i class="far fa-square" v-else></i></td>
					<td><i class="far fa-check-square" v-if="form.form_data.dishonorable_discharge == 'no'"></i><i class="far fa-square" v-else></i></td>
				</tr>
				<tr>
					<td>h. Are you subject to a court order restraining you from harassing, stalking, or threatening your child or an intimate partner or child of such partner?</td>
					<td><i class="far fa-check-square" v-if="form.form_data.restraining_order == 'yes'"></i><i class="far fa-square" v-else></i></td>
					<td><i class="far fa-check-square" v-if="form.form_data.restraining_order == 'no'"></i><i class="far fa-square" v-else></i></td>
				</tr>
				<tr>
					<td>i. Have you ever been convicted in any court of a misdemeanor crime of domestic violence?</td>
					<td><i class="far fa-check-square" v-if="form.form_data.domestic_violence == 'yes'"></i><i class="far fa-square" v-else></i></td>
					<td><i class="far fa-check-square" v-if="form.form_data.domestic_violence == 'no'"></i><i class="far fa-square" v-else></i></td>
				</tr>
				<tr>
					<td class="citizenship" colspan="3">
						<div>12.a. Country of Citizenship. (Check/List more than one, if applicable. Nations of the United States may check U.S.A.)</div>
						<div class="checkbox"><i class="far fa-check-square" v-if="form.form_data.customerValues.CITIZEN_STATUS_CODE == 'C'"></i><i class="far fa-square" v-else></i>United States of America (U.S.A.)</div>
						<div class="checkbox"><i class="far fa-check-square" v-if="form.form_data.customerValues.CITIZEN_STATUS_CODE == 'F'"></i><i class="far fa-square" v-else></i>Other Country/Countries (Specify):</div>
						<span>{{ form.form_data.origin_country }}</span>
					</td>
				</tr>
				<tr>
					<td>12.b. Have you ever renounced your United States citizenship?</td>
					<td><i class="far fa-check-square" v-if="form.form_data.renounced_citizenship == 'yes'"></i><i class="far fa-square" v-else></i></td>
					<td><i class="far fa-check-square" v-if="form.form_data.renounced_citizenship == 'no'"></i><i class="far fa-square" v-else></i></td>
				</tr>
				<tr>
					<td>12.c. Are you an alien <i>illegally</i> or <i>unlawfully</i> in the United States?</td>
					<td><i class="far fa-check-square" v-if="form.form_data.illegal_alien == 'yes'"></i><i class="far fa-square" v-else></i></td>
					<td><i class="far fa-check-square" v-if="form.form_data.illegal_alien == 'no'"></i><i class="far fa-square" v-else></i></td>
				</tr>
				<tr>
					<td>12.d.1. Are you an alien who has been admitted to the United States under a nonimmigrant visa?</td>
					<td><i class="far fa-check-square" v-if="form.form_data.legal_alien == 'yes'"></i><i class="far fa-square" v-else></i></td>
					<td><i class="far fa-check-square" v-if="form.form_data.legal_alien == 'no'"></i><i class="far fa-square" v-else></i></td>
				</tr>
				<tr>
					<td>
						12.d.2. If "yes", do you fall within any of the exceptions stated in the instructions?
						<span class="exc-code-na" v-if="form.form_data.customerValues.EXC_CODE == 'X'"><i class="far fa-check-square"></i>N/A</span>
					</td>
					<td><i class="far fa-check-square" v-if="form.form_data.customerValues.EXC_CODE == 'Y'"></i><i class="far fa-square" v-else></i></td>
					<td><i class="far fa-check-square" v-if="form.form_data.customerValues.EXC_CODE == 'N'"></i><i class="far fa-square" v-else></i></td>
				</tr>
				<tr>
					<td class="mnu" colspan="3">13. If you are an alien, record your U.S.-Issued Alien or Admission Number (AR#, USCIS#, OR I94#): <template v-if="form.form_data.customerValues.CITIZEN_STATUS_CODE != 'C'">{{ form.form_data.customerValues.MNU1 }}</template></td>
				</tr>
			</table>

			<div class="form-line certification">
				<div class="form-full">
					<span><i class="far fa-check-square"></i></span>
					I certify that my answers in Section A are true, correct, and complete. I have read and understand the Notices, Instructions, and Definitions on ATF Form 4473. I understand that answering "yes" to question 11.a. if I am not the actual transferee/buyer is a crime punishable as a felony under Federal law, and may also violate State and/or local law. I understand that a person who answers "yes" to any of the questions 11.b. through 11.i and/or 12.b. through 12.c. is prohibited from purchasing or receiving a firearm. I understand that a person who answers "yes" to question 12.d. is prohibited from receiving or possessing a firearm, unless the person answers "yes" to question 12.d.2. and provides the documentation required in 18.c. I also understand that making any false oral or writeen statement, or exhibiting any false or misinterpreted identification with respect to this transaction, is a crime punishable as a felony under Federal law, and may also violate State and/or local law. I further understand that the repetitive purchase of firearms for the purpose of resale for livelihood and profit without a Federal firearms license is a violation of Federal law.
				</div>
			</div>

			<div class="form-line certification">
				<div class="form-half">
					<div class="label light-font">14. Transferee's/Buyer's Signature</div>
					<div><img class="signature" :src="form.form_data.signature" alt=""></div>
				</div>

				<div class="form-half signature">
					<div class="light-font">15. Date</div>
					<div>{{ $moment(form.form_data.signed_date).format('MM/DD/YYYY') }}</div>
				</div>
			</div>

			<template v-if="form.form_data.section_b">
				<h2 class="section-title">Section B - Must Be Completed By Transferor/Seller</h2>
				<div class="form-line">
					<div class="form-half light-font">
						<div class="light-font">16. Type of firearm(s) to be transferred (check or mark all that apply):</div>
						<label class="checkbox short"><input :disabled="sectionBComplete" type="checkbox" v-model="form.form_data.section_b.customerTransPurpose.l1"><span><i class="fas fa-check-circle"></i>Handgun</span></label>
						<label class="checkbox short"><input :disabled="sectionBComplete" type="checkbox" v-model="form.form_data.section_b.customerTransPurpose.l2"><span class="more-info"><i class="fas fa-check-circle"></i>Long Gun<i class="fas fa-info-circle"><span class="info">(rifles or shotguns)</span></i></span></label>
						<label class="checkbox short"><input :disabled="sectionBComplete" type="checkbox" v-model="form.form_data.section_b.customerTransPurpose.l3"><span class="more-info"><i class="fas fa-check-circle"></i>Other Firearm<i class="fas fa-info-circle"><span class="info">(frame, receiver, etc. See Instructions for Question 16.)</span></i></span></label>
					</div>
					<div class="form-half">
						<div class="light-font">17. If transfer is at a qualifying gun show or event:</div>
						<label>Name of function:</label>
						<input :disabled="sectionBComplete" type="text" v-model="form.form_data.section_b.gun_show_name">
						<label>City, State:</label>
						 <input :disabled="sectionBComplete" type="text" v-model="form.form_data.section_b.gun_show_location">
					</div>
					<div class="help-box-outer form-half">
						<div :class="['help-box-label', showHelp.indexOf(16) > -1 ? 'help-box-label-live' : '']" @click="toggleHelp(16)">Instructions</div>
						<div class="help-box"  v-show="showHelp.indexOf(16) > -1">
							<p>Question 16. Type of Firearm(s): "Other" refers to frames, receivers and other firearms that are neither handguns nor long guns (rifles or shotguns), such as firearms having a pistol grip that expel a shotgun shell, or National Firearms Act (NFA) firearms, including silencers.</p>
							<p>If a frame or receiver can only be made into a long gun (rifle or shotgun), it is still a frame or receiver not a handgun or long gun. However, frames and receivers are still "firearms" by definition, and subject to the same GCA limitations as any other firearms. See Section 921(a)(3)(B). Section 922(b)(1) makes it unlawful for a licensee to sell any firearm other than a shotgun or rifle to any person under the age of 21. Since a frame or receiver for a firearm, to include one that can only be made into a long gun, is a "firearm other than a shotgun or rifle," it cannot be transferred to anyone under the age of 21, nor can these firearms be transferred to anyone who is not a resident of the State where the transfer is to take place. Also, note that multiple sales forms are not required for frames or receivers of any firearms, or pistol grip shotguns, since they are not "pistols or revolvers" under Section 923(g)(3)(A).</p>
						</div>
					</div>
					<div class="help-box-outer form-half">
						<div :class="['help-box-label', showHelp.indexOf(17) > -1 ? 'help-box-label-live' : '']" @click="toggleHelp(17)">Instructions</div>
						<div class="help-box"  v-show="showHelp.indexOf(17) > -1">
							Question 17. Qualifying Gun Show or Event: As defined in 27 CFR 478.100, a gun show or event is a function sponsored by any national, State, or local organization, devoted to the collection, competitive use, or other sporting use of firearms, or an organization or association that sponsors functions devoted to the collection, competitive use, or other sporting use of firearms in the community.
						</div>
					</div>
				</div>

				<div class="form-line">
					<div class="form-full light-font">18.a. Identification (e.g., Virginia Driver's license (VA DL) or other valid government-issued photo identification.) (See Instructions for Question 18.a.)</div>
					<div class="span-1">
						<label>Issuing Authority</label>
						<input :disabled="sectionBComplete" type="text" v-model="form.form_data.section_b.buyer_identification_issuing_authority_and_type">
					</div>
					<div class="span-2">
						<label>Type of Identification</label>
						<select :disabled="sectionBComplete" v-model="form.form_data.section_b.buyer_identification_type_code">
							<option value="">Select...</option>
							<option value="AS">Army Serial Number, National Guard Serial Number or Air National Guard Serial Number, regardless of State</option>
							<option value="CI">Canadian Social Insurance Number</option>
							<option value="DL">Driver's License Number</option>
							<option value="FN">Fingerprint Identification Number</option>
							<option value="MC">Marine Corps Serial Number</option>
							<option value="MD">Mariner's Document or Identification Number</option>
							<option value="NS">Navy Serial Number</option>
							<option value="PP">Passport Number</option>
							<option value="PI">Personal Identification Number (this applies only to state-issued numbers)</option>
							<option value="PS">Port Security Card Number</option>
							<option value="MP">Royal Canadian Mounted Police Identification Number</option>
							<option value="SS">Selective Service Number</option>
							<option value="CG">U.S. Coast Guard Number</option>
							<option value="VA">Veterans Administration Claim Number</option>
							<option value="OA">Other Agency Id</option>
						</select>
						<input v-if="form.form_data.section_b.buyer_identification_type_code == 'OA'" type="text" v-model="form.form_data.section_b.buyer_identification_type_description" placeholder="ID description, e.g. 'State Firearm License'" style="width: 96%;">
					</div>
					<div class="span-1">
						<label>Number on Identification</label>
						<input :disabled="sectionBComplete" type="text" v-model="form.form_data.section_b.buyer_identification_number">
					</div>
					<div class="span-2">
						<label>Expiration Date of Identification (if any)</label>
						<input :disabled="sectionBComplete" type="date" :min="today" v-model="form.form_data.section_b.buyer_identification_expiration_date">
					</div>

					<div class="help-box-outer form-full">
						<div :class="['help-box-label', showHelp.indexOf(18.1) > -1 ? 'help-box-label-live' : '']" @click="toggleHelp(18.1)">Instructions</div>
						<div class="help-box"  v-show="showHelp.indexOf(18.1) > -1">
							<p>18.a. Identification: Before a licensee may sell or deliver a firearm to a nonlicensee, the licensee must establish the identity, place of residence, and age of the transferee/buyer. The transferee/buyer must provide a valid government- issued photo identification document to the transferor/seller that contains the transferee's/buyer's name, residence address, and date of birth. A driver's license or an identification card issued by a State in place of a license is acceptable. Social Security cards are not acceptable because no address, date of birth, or photograph is shown on the cards. A combination of government-issued documents may be provided. See instructions for question 18.b. Supplemental Documentation.</p>
							<p>If the transferee/buyer is a member of the Armed Forces on active duty acquiring a firearm in the State where his/her permanent duty station is located, but he/she has a driver's license from another State, the transferor/seller should list the transferee's/buyer's military identification card and official orders showing where his/her permanent duty station is located in response to question 18.a. Licensees may accept electronic PCS orders to establish residency.</p>
						</div>
					</div>
				</div>

				<div class="form-line">
					<div class="light-font form-full">
						<p>18.b. Supplemental Government Issued Documentation (if identification document does not show current residence address) (See Instructions for Question 18.b.)</p>
						<input :disabled="sectionBComplete" type="text" v-model="form.form_data.section_b.buyer_supplemental_government_documentation">
					</div>

					<div class="help-box-outer form-full">
						<div :class="['help-box-label', showHelp.indexOf(18.2) > -1 ? 'help-box-label-live' : '']" @click="toggleHelp(18.2)">Instructions</div>
						<div class="help-box"  v-show="showHelp.indexOf(18.2) > -1">
							<p>Question 18.b. Supplemental Documentation: Licensees may accept a combination of valid government-issued documents to satisfy the identification document requirements of the law. The required valid government-issued photo identification document bearing the name, photograph, and date of birth of transferee/buyer may be supplemented by another valid, government-issued document showing the transferee's/buyer's residence address. This supplemental documentation should be recorded in question 18.b., with the issuing authority and type of identification presented. For example, if the transferee/buyer has two States of residence and is trying to buy a handgun in State X, he may provide a driver's license (showing his name, date of birth, and photograph) issued by State Y and another government-issued document (such as a tax document) from State X showing his residence address. A valid electronic document from a government website may be used as supplemental documentation provided it contains the transferee's/buyer's name and current residence address.</p>
						</div>
					</div>
				</div>

				<div class="form-line">
					<div class="light-font form-full">
						<p>18.c. Exception to the Nonimmigrant Alien Prohibition: If the transferee/buyer answered "YES" to 12.d.2. the transferor/seller must record the type of documentation showing the exception to the prohibition and attach a copy to this ATF Form 4473. (See Instructions for Question 18.c.)</p>
						<input :disabled="sectionBComplete" type="text" v-model="form.form_data.section_b.exception_to_the_nonimmigrant_alien_prohibition_documentation">
					</div>
					<div class="help-box-outer form-full">
						<div :class="['help-box-label', showHelp.indexOf(18.3) > -1 ? 'help-box-label-live' : '']" @click="toggleHelp(18.3)">Instructions</div>
						<div class="help-box"  v-show="showHelp.indexOf(18.3) > -1">
							<p>Question 18.c. Exceptions to the Nonimmigrant Alien Prohibition and Acceptable Documentation: An alien admitted to the United States under a nonimmigrant visa is not prohibited from purchasing, receiving, or possessing a firearm if the alien: (1) is in possession of a hunting license or permit lawfully issued by the Federal Government, a State or local government, or an Indian tribe federally recognized by the Bureau of Indian Affairs, which is valid and unexpired; (2) was admitted to the United States for lawful hunting or sporting purposes; (3) has received a waiver from the prohibition from the Attorney General of the United States; (4) is an official representative of a foreign government who is accredited to the United States Government or the Government's mission to an international organization having its headquarters in the United States; (5) is an official representative of a foreign government who is en route to or from another country to which that alien is accredited; (6) is an official of a foreign government or a distinguished foreign visitor who has been so designated by the Department of State; or (7) is a foreign law enforcement officer of a friendly foreign government entering the United States on official law enforcement business.</p>
						</div>
					</div>
				</div>

				<div class="controls nics-check">
					<template v-if="readyForNICSCheck">
						<div id="nics_online_check_button" class="primary button" @click="nicsOnlineCheck = true">NICS Online Check</div>
						<div class="primary button col-2" @click="nicsPhoneCheck = true">NICS Phone Check</div>
					</template>
					<template v-else>
						<div class="primary button disabled">NICS Online Check</div>
						<div class="primary button disabled col-2">NICS Phone Check</div>
					</template>
				</div>

				<div class="form-line grid-four">
					<div class="light-font form-half" style="padding: 0 1em 0 0;">
						19.a. Date the transferee's/buyer's identifying information was transmitted to NICS or the appropriate State agency:
					</div>
					<div class="light-font form-half">19.b. The NICS or State transaction number <em>(if provided)</em> was:</div>
					<input :disabled="sectionBComplete" class="form-half" type="date" ref="nics_initial_response_date" v-model="form.form_data.section_b.nics_initial_response_date">
					<input :disabled="sectionBComplete" class="form-half" ref="form_nics_number" v-model="form.nics_number" type="text" >
					<div class="help-box-outer form-full">
						<div :class="['help-box-label', showHelp.indexOf(19) > -1 ? 'help-box-label-live' : '']" @click="toggleHelp(19)">Instructions</div>
						<div class="help-box"  v-show="showHelp.indexOf(19) > -1">
							<p>Question 19. NICS BACKGROUND CHECKS: 18 U.S.C. 922(t) requires that prior to transferring any firearm to an unlicensed person, a licensed importer, manufacturer, or dealer must first contact the National Instant Criminal Background Check System (NICS). NICS will advise the licensee whether the system finds any information that the purchaser is prohibited by law from possessing or receiving a firearm. For purposes of this form, contacts to NICS include State agencies designated as points-of-contact ("or POCs") to conduct NICS checks for the Federal Government.</p>
							<p>The licensee should NOT contact NICS and must stop the transaction if there is reasonable cause to believe that the transferee/buyer is prohibited from receiving or possessing a firearm, including if: the transferee/buyer answers "no" to question 11.a.; the transferee/buyer answers "yes" to any question in 11.b. - 11.i. or 12.b. - 12.c.; the transferee/buyer has answered "yes" to question 12.d.l., and answered "no" to question 12.d.2.; or the transferee/buyer cannot provide the documentation required by questions 18.a, b, or c. WARNING: Any person who transfers a firearm to any person he/she knows or has reasonable cause to believe is prohibited from receiving or possessing a firearm violates the law, even if the transferor/seller has complied with the Federal background check requirements.</p>
							<p>At the time that NICS is contacted, the licensee must record in question 19.a. - 19.c.: the date of contact, the NICS (or State) transaction number, and the initial (first) response provided by NICS or the State. The licensee may record the date the firearms may be transferred to the transferee/buyer (also known as the Missing Disposition Information (MDI) date) in 19.c. that NICS provides for delayed transactions (States may not provide this date). If the licensee receives any subsequent response(s) before transferring the firearm, the licensee must record in question 19.d. any response later provided by NICS or the State, or that no response was provided within 3 business days. If the transaction was denied and later overturned in addition to checking the "Proceed" and entering the date, the licensee must also check the "Overturned" box and, if provided, attach the overturn certificate issued by NICS or the State POC to the ATF Form 4473. If the licensee receives a response from NICS or the State after the firearm has been transferred, he/she must record this information in question 19.e. Note: States acting as points of contact for NICS checks may use terms other than "proceed," "delayed," "canceled," or "denied." In such cases, the licensee should check the box that corresponds to the State's response. Some States may not provide a transaction number for denials. However, if a firearm is transferred within the three business day period, a transaction number is required.</p>
							<p>NICS responses: If NICS provides a "proceed" response, the transaction may proceed. If NICS provides a "canceled" or "denied" response, the transferor/seller is prohibited from transferring the firearm to the transferee/buyer. If NICS provides a "delayed" response, the transferor/seller is prohibited from transferring the firearm unless 3 business days have elapsed and, before the transfer, NICS or the State has not advised the transferor/seller that the transferee's/buyer's receipt or possession of the firearm would be in violation of law. (See 27 CFR 478.102(a) for an example of how to calculate 3 business days.) If NICS provides a "delayed" response, NICS also will provide a Missing Disposition Information (MDI) date that calculates the 3 business days and reflects when the firearm(s) can be transferred under Federal law. States may not provide an MDI date. State law may impose a waiting period on transferring firearms.</p>
						</div>
					</div>
				</div>

				<div class="form-line">
					<div class="form-full light-font">19.c. The response initially (first) provided by NICS or the appropriate State agency was:</div>
					<div class="form-full">
						<label class="radio"><input type="radio" v-model="form.form_data.section_b.nics_initial_response" name="nics_initial_response" id="nics_status_proceed" value="Proceed"><span class="proceed"><i class="fas fa-check-circle"></i>Proceed</span></label>
						<label class="radio"><input type="radio" v-model="form.form_data.section_b.nics_initial_response" name="nics_initial_response" id="nics_status_denied" value="Denied"><span class="denied"><i class="fas fa-check-circle"></i>Denied</span></label>
						<label class="radio"><input type="radio" v-model="form.form_data.section_b.nics_initial_response" name="nics_initial_response" id="nics_status_delayed" value="Delayed"><span class="delayed"><i class="fas fa-check-circle"></i>Delayed</span></label>
						<label class="radio"><input type="radio" v-model="form.form_data.section_b.nics_initial_response" name="nics_initial_response" id="nics_status_canceled" value="Canceled"><span class="canceled"><i class="fas fa-check-circle"></i>Canceled</span></label>
						<label>The firearm(s) may be transferred on <input type="date" :min="today" v-model="form.form_data.section_b.nics_firearm_may_be_transferred"> if State law permits (optional)</label>
					</div>
				</div>

				<div class="controls">
					<div class="primary button" @click="saveSectionB">Save Section B</div>
					<a class="primary button" :href="generatePDFLink()" target="_blank">Print</a>
					<router-link to="/logbooks/4473" tag="div" class="primary button"><i class="fa fa-arrow-circle-left"></i> Back To List</router-link>
					<i class="far fa-compass fa-spin" v-if="printing || savingSection == 'section_b'"></i>
				</div>

				<div class="form-line grid-five">
					<div class="form-full light-font">19.d. The following response(s) was/were later received from NICS or the appropriate State agency:</div>
					<div class="form-full">
						<label class="checkbox">
							<input type="checkbox" id="nics_later_response_proceed" v-model="form.form_data.section_b.nics_later_response_proceed">
							<span class="proceed"><i class="fas fa-check-circle"></i>Proceed</span>
						</label>
						<label class="date-label"><input id="nics_later_response_proceed_date" type="date" :min="today" v-model="form.form_data.section_b.nics_later_response_proceed_date">(date)</label>
						<label class="checkbox">
							<input type="checkbox" id="nics_later_response_denied" v-model="form.form_data.section_b.nics_later_response_denied">
							<span class="denied"><i class="fas fa-check-circle"></i>Denied</span>
						</label>
						<label class="date-label"><input id="nics_later_response_denied_date" type="date" :min="today" v-model="form.form_data.section_b.nics_later_response_denied_date">(date)</label>
						<label class="checkbox">
							<input type="checkbox" id="nics_later_response_canceled" v-model="form.form_data.section_b.nics_later_response_canceled">
							<span class="canceled"><i class="fas fa-check-circle"></i>Canceled</span>
						</label>
						<label class="date-label"><input id="nics_later_response_canceled_date" type="date" :min="today" v-model="form.form_data.section_b.nics_later_response_canceled_date">(date)</label>
						<label class="checkbox">
							<input type="checkbox" id="nics_later_response_no_response" v-model="form.form_data.section_b.nics_later_response_no_response">
							<span>
								<i class="fas fa-check-circle"></i>
								No response was provided within 3 business days.
							</span>
						</label>
						<label class="checkbox">
							<input type="checkbox" id="nics_later_response_overturned" v-model="form.form_data.section_b.nics_later_response_overturned">
							<span><i class="fas fa-check-circle"></i>Overturned</span>
						</label>
					</div>
				</div>

				<div class="form-line">
					<div class="form-full light-font">19.e. (Complete if applicable.) After the firearm was transferred, the following response was received from NICS or the appropriate State agency on:</div>
					<div class="form-full">
						<label>Date: <input type="date" :min="today" v-model="form.form_data.section_b.nics_after_transfer_response_date"></label>
						<label class="radio">
							<input type="radio" @click="form.form_data.section_b.nics_after_transfer_response = !form.form_data.section_b.nics_after_transfer_response" v-model="form.form_data.section_b.nics_after_transfer_response" value="Proceed">
							<span class="proceed"><i class="fas fa-check-circle"></i>Proceed</span>
						</label>
						<label class="radio">
							<input type="radio" @click="form.form_data.section_b.nics_after_transfer_response = !form.form_data.section_b.nics_after_transfer_response" v-model="form.form_data.section_b.nics_after_transfer_response" value="Denied">
							<span class="denied"><i class="fas fa-check-circle"></i>Denied</span>
						</label>
						<label class="radio">
							<input type="radio" @click="form.form_data.section_b.nics_after_transfer_response = !form.form_data.section_b.nics_after_transfer_response" v-model="form.form_data.section_b.nics_after_transfer_response" value="Canceled">
							<span class="canceled"><i class="fas fa-check-circle"></i>Canceled</span>
						</label>
					</div>
				</div>

				<div class="form-line">
					<div class="form-full light-font">19.f. The name and Brady identification number of the NICS examiner. (Optional)</div>
					<div class="span-2">
						<label>Name:</label><input :disabled="sectionBComplete" type="text" v-model="form.form_data.section_b.nics_examiner_name">
					</div>
					<div class="span-2">
						<label>Number:</label><input :disabled="sectionBComplete" type="text" v-model="form.form_data.section_b.nics_examiner_brady_number">
					</div>
				</div>

				<div class="form-line">
					<div class="form-full light-font">19.g. Name of FFL Employee Completing NICS check. (Optional)</div>
					<div class="span-2">
						<input :disabled="sectionBComplete" type="text" v-model="form.form_data.section_b.employee_completing_nics">
					</div>
				</div>

				<div class="form-line">
					<div class="form-full light-font">20.
						<label class="checkbox">
							<input :disabled="sectionBComplete" type="checkbox" v-model="form.form_data.section_b.nics_buyer_background_check">
							<span>
								<i class="fas fa-check-circle"></i>
								<span class="on-value">{{ onValue }}</span>
								<span class="off-value">{{ offValue }}</span>
							</span>
						</label>
						<div>No NICS check was required because a background check was completed during the NFA approval process on the individual who will receive the NFA firearm(s), as reflected on the approved NFA application. (See Instructions for Question 20.)</div>
					</div>
				</div>

				<div class="form-line grid-four">
					<div class="form-full light-font">21.
						<label class="checkbox">
							<input :disabled="sectionBComplete" type="checkbox" v-model="form.form_data.section_b.nics_buyer_exempt">
							<span>
								<i class="fas fa-check-circle"></i>
								<span class="on-value">{{ onValue }}</span>
								<span class="off-value">{{ offValue }}</span>
							</span>
						</label>
						<div>No NICS check was required because the transferee/buyer has a valid permit from the State where the transfer is to take place, which qualifies as an exemption to NICS. (See Instructions for Question 21.)</div>
					</div>
					<div>
						<label>Issuing State and Permit Type</label>
						<input :disabled="sectionBComplete" type="text" v-model="form.form_data.section_b.nics_buyer_exempt_permit_state_type">
					</div>
					<div>
						<label>Date of Issuance (if any)</label>
						<input :disabled="sectionBComplete" type="text" v-model="form.form_data.section_b.nics_buyer_exempt_permit_date_issuance">
					</div>
					<div>
						<label>Expiration Date (if any)</label>
						<input :disabled="sectionBComplete" type="text" v-model="form.form_data.section_b.nics_buyer_exempt_permit_date_expiration">
					</div>
					<div>
						<label>Permit Number (if any)</label>
						<input :disabled="sectionBComplete" type="text" v-model="form.form_data.section_b.nics_buyer_exempt_permit_number">
					</div>

					<div class="help-box-outer form-full">
						<div :class="['help-box-label', showHelp.indexOf(20) > -1 ? 'help-box-label-live' : '']" @click="toggleHelp(20)">Instructions</div>
						<div class="help-box"  v-show="showHelp.indexOf(20) > -1">
							<p>Questions 20 and 21. NICS Exceptions: A NICS check is not required if the transfer qualifies for any of the exceptions in 27 CFR 478.102(d). Generally these include: (a) transfers of National Firearms Act firearms to an individual who has undergone a background check during the NFA approval process; (b) transfers where the transferee/buyer has presented the licensee with a permit or license that allows the transferee/buyer to possess, acquire, or carry a firearm, and the permit has been recognized by ATF as a valid alternative to the NICS check requirement; or (c) transfers certified by ATF as exempt because compliance with the NICS check requirements is impracticable. If the transfer qualifies for one of these exceptions, the licensee must obtain the documentation required by 27 CFR 478.131. A firearm must not be transferred to any transferee/buyer who fails to provide such documentation.</p>
							<p>A NICS check must be conducted if an NFA firearm has been approved for transfer to a trust, or to a legal entity such as a corporation, and no background check was conducted as part of the NFA approval process on the individual who will receive the firearm. Individuals who have undergone a background check during the NFA application process are listed on the approved NFA transfer form.</p>
						</div>
					</div>
				</div>
				<div class="controls">
					<div class="primary button" @click="saveSectionB">Save Section B</div>
					<a class="primary button" :href="generatePDFLink()" target="_blank">Print</a>
					<router-link to="/logbooks/4473" tag="div" class="primary button"><i class="fa fa-arrow-circle-left"></i> Back To List</router-link>
					<i class="far fa-compass fa-spin" v-if="printing || savingSection == 'section_b'"></i>
				</div>
			</template>

			<template v-if="section_c">
				<h2 class="section-title">Section C - Must Be Completed Personally By Transferee/Buyer</h2>
				<div class="form-line">
					<div class="form-full">If the transfer of the firearm(s) takes place on a different day from the date that the transferee/buyer signed Section A, the transferee/buyer must complete Section C immediately prior to the transfer of the firearm(s).<br>(See Instructions for Question 22 and 23.)</div>
				</div>

				<div class="form-line">
					<template v-if="form.form_data.section_c">
						<div class="form-full dark-font">I certify that my answers to the questions in Section A of this form are still true, correct, and complete.</div>
						<div class="form-half light-font"><label>22. Transferee's/Buyer's Signature</label><img class="signature" :src="form.form_data.section_c.buyer_recertification_signature" alt=""></div>
						<div class="form-half light-font"><label>23. Recertification Date</label><input disabled type="date" :min="today" v-model="form.form_data.section_c.buyer_recertification_date"></div>
					</template>
					<div class="help-box-outer form-full">
						<div :class="['help-box-label', showHelp.indexOf(22) > -1 ? 'help-box-label-live' : '']" @click="toggleHelp(22)">Instructions</div>
						<div class="help-box"  v-show="showHelp.indexOf(22) > -1">
							<p>Questions 22 and 23. Transfer on a Different Day and Recertification: If the transfer takes place on a different day from the date that the transferee/buyer signed Section A, the licensee must again check the photo identification of the transferee/buyer at the time of transfer.</p>
						</div>
					</div>
				</div>
				<div class="controls">
					<div class="primary button" @click="saveSectionC" v-if="sectionCValid && sectionCSaveEnabled">Save Section C</div>
					<div class="primary button disabled" v-else>Save Section C</div>
					<a class="primary button" :href="generatePDFLink()" target="_blank">Print</a>
					<router-link to="/logbooks/4473" tag="div" class="primary button"><i class="fa fa-arrow-circle-left"></i> Back To List</router-link>
					<i class="far fa-compass fa-spin" v-if="printing || savingSection == 'section_c'"></i>
				</div>

				<h2 class="section-title">Section D - Must Be Completed By Transferor/Seller Even If The Firearm(s) is Not Transferred</h2>

				<template v-if="form.form_data && form.form_data.section_d">
					<table class="firearms-list" cellspacing="0" cellpadding="0">
						<tr>
							<th>24. Manufacturer and Importer (If any) (If the manufacturer and importer are different, the FFL must include both.)</th>
							<th>25. Model (If Designated)</th>
							<th>26. Serial Number</th>
							<th>27. Type (See Instructions for Question 27.)</th>
							<th>28. Caliber or Gauge</th>
						</tr>
						<tr v-for="(firearm, index) in form.form_data.section_d.firearms_list" :key="index" :class="{ incomplete: firearmsIncomplete.includes(index) }">
							<td><label>{{ index + 1 }}.</label><input :disabled="completeSections.section_d" type="text" v-model="firearm.manufacturer" @keyup="checkFirearmsList"></td>
							<td><input :disabled="completeSections.section_d" type="text" v-model="firearm.model" @keyup="checkFirearmsList"></td>
							<td>
								<input :disabled="completeSections.section_d" type="text" v-model="firearm.serial_number" @keyup="checkFirearmsList" @keyup.enter="serialSearch(index, firearm.serial_number)">
								<i v-if="!completeSections.section_d" class="fas fa-search" @click="serialSearch(index, firearm.serial_number)"></i>
							</td>
							<td><input :disabled="completeSections.section_d" type="text" v-model="firearm.gun_type" @keyup="checkFirearmsList"></td>
							<td><input :disabled="completeSections.section_d" type="text" v-model="firearm.caliber" @keyup="checkFirearmsList">
								<div class="loading" v-if="firearmSearchResults.length == 0 && serialNumberLookup == index"><i class="far fa-compass fa-spin"></i></div>
								<div class="firearm-lookup-message" v-if="firearmMessageIndex == index">{{ firearmMessage }}</div>
								<div class="firearm-lookup-message" v-if="firearmSearchResults.length > 0 && serialNumberLookup == index">
									<ul class="search-list" style="float: left; margin-left: calc(50vw - 22em);">
										<li class="clickable-list-item" v-for="(firearm, subindex) in firearmSearchResults" @click="assignFirearmsList(index,firearm)">
											<span>Sequence: <b>{{ firearm.ffl_log_book_code }}-{{ firearm.sequence_number }}</b></span>
											<span>{{ firearm.manufacturer }} {{ firearm.model }}</span>
											<span>Serial Number: <b>{{ firearm.serial_number }}</b></span>
											<span>{{ firearm.gun_type }} {{ firearm.caliber }}</span>
										</li>
									</ul>
									<button class="button action search-list-cancel" style="font-size: 0.7em; float: left;" @click="cancelSerialNumberSearchResults()">X</button>
								</div>
								<div v-if="firarmEditingIndex == index" class="firearm-edit-message">
									Finish making your changes to this firearm.
									<button class="button action" @click="confirmFirearmEdit(index)">Save</button>
									<button class="button cancel" @click="revertFirearmEdit(index)">Cancel</button>
								</div>

							</td>
						</tr>
					</table>

					<div class="form-line" style="border-top: 0 none;">
						<div class="help-box-outer form-full">
							<div :class="['help-box-label', showHelp.indexOf(24) > -1 ? 'help-box-label-live' : '']" @click="toggleHelp(24)">Instructions</div>
							<div class="help-box"  v-show="showHelp.indexOf(24) > -1">
								<p>Question 24-28. Firearm(s) Description: These blocks must be completed with the firearm(s) information. Firearms manufactured after 1968 by Federal firearms licensees should all be marked with a serial number. Should you acquire a firearm that is legally not marked with a serial number (i.e. pre-1968); you may answer question 26 with "NSN" (No Serial Number), "N/A" or "None."</p>
								<p>If more than four firearms are involved in a transaction, the information required by Section D, questions 24-28, must be provided for the additional firearms on a separate sheet of paper, which must be attached to this ATF Form 4473.</p>
								<p>Types of firearms include, but are not limited to: pistol, revolver, rifle, shotgun, receiver, frame and other firearms that are neither handguns nor long guns (rifles or shotguns), such as firearms having a pistol grip that expel a shotgun shell (pistol grip firearm) or NFA firearms (machinegun, silencer, short-barreled shotgun, short-barreled rifle, destructive device or "any other weapon").</p>
								<p>Additional firearms purchases by the same transferee/buyer may not be added to the form after the transferor/seller has signed and dated it. A transferee/buyer who wishes to acquire additional firearms after the transferor/seller has signed and dated the form must complete a new ATF Form 4473 and undergo a new NICS check.</p>
							</div>
						</div>
					</div>

					<div class="controls">
						<div class="primary button" @click="saveSectionD" v-if="sectionDValid && !completeSections.section_d">Save Section D</div>
						<div class="primary button disabled" v-else>Save Section D</div>
						<a class="primary button" :href="generatePDFLink()" target="_blank">Print</a>
						<router-link to="/logbooks/4473" tag="div" class="primary button"><i class="fa fa-arrow-circle-left"></i> Back To List</router-link>
						<i class="far fa-compass fa-spin" v-if="printing || savingSection == 'section_d'"></i>
						<div class="error firearms-incomplete-message" v-if="firearmsIncomplete.length > 0">Firearms indicated in red above are incomplete and will not be saved.</div>
					</div>

					<h2 class="section-title">REMINDER - By the Close of Business Complete ATF Form 3310.4 For Multiple Purchases of Handguns Within 5 Consecutive Business Days</h2>

					<div class="form-line">
						<div class="light-font">29. Total Number of Firearms Transferred (Please handwrite by printing e.g., zero, one, two, three, etc. Do not use numerals.)</div>
						<div class="form-half"><input :disabled="completeSections.section_d" type="text" v-model="form.form_data.section_d.total_firearms_transferred" readonly></div>
					</div>

					<div class="form-line">
						<div class="light-font">30. Check if any part of this transaction is a pawn redemption.</div>
						<div class="form-half">
						<label><input :disabled="completeSections.section_d" type="checkbox"  v-model="form.form_data.section_d.transaction_pawn_redemption">Line Number(s) From Question 24 Above: </label><input :disabled="completeSections.section_d" type="text" v-model="form.form_data.section_d.transaction_pawn_redemption_line_numbers">
						</div>
					</div>

					<div class="form-line">
						<div class="light-font">31. For Use by Licensee (See Instructions for Question 31.)</div>
						<div class="form-half">
						<textarea :disabled="completeSections.section_d" v-model="form.form_data.section_d.seller_notes"></textarea>
						</div>

						<div class="help-box-outer form-full">
							<div :class="['help-box-label', showHelp.indexOf(31) > -1 ? 'help-box-label-live' : '']" @click="toggleHelp(31)">Instructions</div>
							<div class="help-box"  v-show="showHelp.indexOf(31) > -1">
								Question 31. This item is for the licensee's use in recording any information he/she finds necessary to conduct business.
							</div>
						</div>
					</div>

					<div class="form-line">
						<div class="light-font">32. Check if this transaction is to facilitate a private party transfer.</div>
						<div class="form-half">
						<label><input :disabled="completeSections.section_d" type="checkbox" v-model="form.form_data.section_d.private_party_transfer">(See Instructions for Question 32.)</label>
						</div>

						<div class="help-box-outer form-full">
							<div :class="['help-box-label', showHelp.indexOf(32) > -1 ? 'help-box-label-live' : '']" @click="toggleHelp(32)">Instructions</div>
							<div class="help-box"  v-show="showHelp.indexOf(32) > -1">
								Question 32. Check this box, or write "Private Party Transfer" in question 31, if the licensee is facilitating the sale or transfer of a firearm between private unlicensed individuals in accordance with ATF Procedure 2013-1. This will assist the licensee by documenting which transaction records correspond with private party transfers, and why there may be no corresponding A&D entries when the transfer did not proceed because it was denied, delayed, or canceled.
							</div>
						</div>
					</div>

					<div class="form-line">
						<div class="light-font">33. Trade/corporate name and address of transferor/seller and Federal Firearm License Number (Must contain at least first three and last five digits of FFL Number X-XX-XXXXX.) (Hand stamp may be used.)</div>
						<div class="form-half">
						<textarea :disabled="completeSections.section_d" class="dealer-address" v-model="form.form_data.section_d.seller_name_address_ffl"></textarea>
						</div>
					</div>
				</template>

				<div class="controls">
					<div class="primary button" @click="saveSectionD" v-if="sectionDValid && !completeSections.section_d">Save Section D</div>
					<div class="primary button disabled" v-else>Save Section D</div>
					<a class="primary button" :href="generatePDFLink()" target="_blank">Print</a>
					<router-link to="/logbooks/4473" tag="div" class="primary button"><i class="fa fa-arrow-circle-left"></i> Back To List</router-link>
					<i class="far fa-compass fa-spin" v-if="printing || savingSection == 'section_d'"></i>
					<div class="error firearms-incomplete-message" v-if="firearmsIncomplete.length > 0">Firearms indicated in red above are incomplete and will not be saved.</div>
				</div>
			</template>

			<template v-if="section_d">
				<h2 class="section-title">The Person Transferring The Firearm(s) Must Complete Questions 34-37.<br>
				For Denied/Canceled Transactions, the Person Who Completed Section B Must Complete Questions 34-36.</h2>

				<h2 class="section-title left">I certify that: (1) I have read and understand the Notices, Instructions, and Definitions on this ATF Form 4473; (2) the information recorded in Sections B and D is true, correct, and complete; and (3) this entire transaction record has been completed at my licensed business premises ("licensed premises" includes business temporarily conducted from a qualifying gun show or event in the same State in which the licensed premises is located) unless this transaction has met the requirements of 18 U.S.C. 922(c). Unless this transaction has been denied or canceled, I further certify on the basis of — (1) the transferee's/buyer's responses in Section A (and Section C, if applicable); (2) my verification of the identification recorded in question 18 (and my re-verification at the time of transfer, if Section C was completed); and (3) State or local law applicable to the firearms business — it is my belief that it is not unlawful for me to sell, deliver, transport, or otherwise dispose of the firearm(s) listed on this form to the person identified in Section A.</h2>

				<div class="form-line">
					<div class="light-font">34. Transferor's/Seller's Name (Please print)</div>
					<div class="form-half">
						<input type="text" v-model="form.form_data.section_final.seller_name" v-if="form.form_data.section_final && form.form_data.section_final.seller_name">
						<input type="text" v-model="section_final.seller_name" v-else>
					</div>

					<div class="light-font">35. Transferor's/Seller's Signature</div>

					<div v-if="form.form_data.section_final && form.form_data.section_final.seller_signature" class="form-half">
						<img class="signature" style="float: left;" :src="form.form_data.section_final.seller_signature" alt="">
						<div class="cancel-signature" @click="cancelSellerSignature()"><i class="fas fa-times"></i></div>
					</div>
					<div class="signature-group" v-else>
						<canvas id="seller_signature_pad" width="800" height="213" @click="clearSellerCanvas"></canvas>
					</div>

					<div class="light-font">36. Transferor's/Seller's Title</div>
					<div class="form-half">
						<input type="text" v-model="form.form_data.section_final.seller_title" v-if="form.form_data.section_final && form.form_data.section_final.seller_title">
						<input type="text" v-model="section_final.seller_title" v-else>
					</div>

					<div class="light-font">37. Date Transferred</div>
					<div class="form-half">
						<input type="date" :min="today" v-model="form.form_data.section_final.transfer_date" v-if="form.form_data.section_final && form.form_data.section_final.transfer_date">
						<input type="date" :min="today" v-model="section_final.transfer_date" v-else>
						<div style="display: inline-block; margin: 0 0 0 1em;"><label>
							<input type="checkbox" v-model="form.form_data.section_final.not_transferred" v-if="form.form_data.section_final && form.form_data.section_final.not_transferred" @click="toggleNotTransferred()">
							<input type="checkbox" v-model="section_final.not_transferred" v-else @click="toggleNotTransferred()">
						 Not Transferred</label></div>
					</div>
				</div>

				<div class="controls section-final">
					<div class="primary button" @click="saveSectionFinal" v-if="sectionFinalValid && !sectionFinalComplete">Save Final Section</div>
					<div class="primary button disabled" v-else>Save Final Section</div>
					<a class="primary button" :href="generatePDFLink()" target="_blank">Print</a>
					<router-link to="/logbooks/4473" tag="div" class="primary button"><i class="fa fa-arrow-circle-left"></i> Back To List</router-link>
					<i class="far fa-compass fa-spin" v-if="printing || savingSection == 'section_final'"></i>
				</div>
			</template>

			<div class="form-line">
				<div class="help-box-outer form-full">
					<div :class="['help-box-label', showHelp.indexOf(38) > -1 ? 'help-box-label-live' : '']" @click="toggleHelp(38)">Instructions</div>
					<div class="help-box"  v-show="showHelp.indexOf(38) > -1">
						<h4>Privacy Act Information</h4>
						<p>Solicitation of this information is authorized under 18 U.S.C. 923(g). Disclosure of this information by the transferee/buyer is mandatory for the transfer of a firearm. Disclosure of the individual's Social Security number is voluntary. The number may be used to verify the transferee's/buyer's identity.</p>
						<p>For information about the routine uses of this form see System of Records Notice Justice/ATF-008, Regulatory Enforcement Records System (68 FR 163558, January 24, 2003).</p>
						<h4>Paperwork Reduction Act Notice</h4>
						<p>The information required on this form is in accordance with the Paperwork Reduction Act of 1995. The purpose of the information is to determine the eligibility of the transferee to receive and possess firearms under Federal law. The information is subject to inspection by ATF officers and is required by 18 U.S.C. 922 and 923.</p>
						<p>The estimated average burden associated with this collection is 30 minutes per respondent or recordkeeper, depending on individual circumstances. Comments about the accuracy of this burden estimate and suggestions for reducing it should be directed to Reports Management Officer, IT Coordination Staff, Bureau of Alcohol, Tobacco, Firearms and Explosives, Washington, DC 20226.</p>
						<p>An agency may not conduct or sponsor, and a person is not required to respond to, a collection of information unless it displays a currently valid OMB control number. Confidentiality is not assured.</p>
					</div>
				</div>
			</div>
		</div>

		<div class="transaction-purpose modal" v-if="nicsPhoneCheck && !(continueCheck && customerTransPurposeSet)">
			<div class="inner">
				<h2>Transaction Purpose</h2>
				<div class="content">
					<label><input type="checkbox" v-model="customerTransPurpose.l1">Handgun</label>
					<label><input type="checkbox" v-model="customerTransPurpose.l2">Long Gun</label>
					<label><input type="checkbox" v-model="customerTransPurpose.l3">Other Firearm</label>
					<label><input type="checkbox" v-model="customerTransPurpose.l4">Pre-pawn of hand gun</label>
					<label><input type="checkbox" v-model="customerTransPurpose.l5">Pre-pawn of long gun</label>
					<label><input type="checkbox" v-model="customerTransPurpose.l6">Pre-pawn of other</label>
					<label><input type="checkbox" v-model="customerTransPurpose.l7">Redemption of hand gun </label>
					<label><input type="checkbox" v-model="customerTransPurpose.l8">Redemption of long gun</label>
					<label><input type="checkbox" v-model="customerTransPurpose.l9">Redemption of other</label>
					<label><input type="checkbox" v-model="customerTransPurpose.l10">Private Sale hand gun</label>
					<label><input type="checkbox" v-model="customerTransPurpose.l11">Private Sale Long gun</label>
					<label><input type="checkbox" v-model="customerTransPurpose.l12">Private Sale Other</label>
					<label><input type="checkbox" v-model="customerTransPurpose.l13">Private Sale Returned to Seller Hand gun</label>
					<label><input type="checkbox" v-model="customerTransPurpose.l14">Private Sale Returned to Seller Long gun</label>
					<label><input type="checkbox" v-model="customerTransPurpose.l15">Private Sale Returned to Seller Other</label>
				</div>

				<div class="controls">
					<div class="cancel button" @click="nicsPhoneCheck = continueCheck = false">Cancel</div>
					<div class="primary button" @click="continueCheck = true" v-if="customerTransPurposeSet">Continue</div>
					<div class="primary button disabled" v-else>Continue</div>
				</div>
			</div>
		</div>

		<div class="nics-phone-check modal" v-else-if="nicsPhoneCheck">
			<div class="inner">
				<div class="content">
					<div class="small" style="float: right;">Scroll for all phone check info<br>and to enter result.</div>
					<h1>NICS Phone Check</h1>
					<div><span>Customer Name</span> <span>{{ form.form_data.customerValues.LAST_NAME }} {{ form.form_data.customerValues.FIRST_NAME }}</span></div>
					<div><span>First Name</span> <span>{{ form.form_data.customerValues.FIRST_NAME }}</span></div>
					<div><span>Last Name</span> <span>{{ form.form_data.customerValues.LAST_NAME }}</span></div>
					<div><span>Middle Name</span> <span>{{ form.form_data.customerValues.MIDDLE_NAME }}</span></div>
					<div><span>Height</span> <span>{{ form.form_data.customerValues.HEIGHT }}</span></div>
					<div><span>Weight</span> <span>{{ form.form_data.customerValues.WEIGHT }}</span></div>
					<div><span>Gender</span> <span>{{ form.form_data.customerValues.GENDER_CODE }}</span></div>
					<div><span>Date of Birth</span> <span>{{ $moment(form.form_data.customerValues.DOB).format('DD/MM/YYYY') }}</span></div>
					<div>
						<span>Place of Birth</span>
						<span>{{ form.form_data.customerValues.POB_CODE }}</span>
					</div>
					<div><span>Ethnicity</span><span>{{ form.form_data.ethnicity }}</span></div>
					<div>
						<span>Race Code</span>
						<ul class="customer-race-list"><li v-for="(race, index) in customerRaceCodes" :key="index">{{ race }}</li></ul>
					</div>
					<div><span>State</span> <span>{{ form.form_data.customerValues.STATE_CODE }}</span></div>
					<div>
						<span>Citizenship</span>
						<span v-if="form.form_data.customerValues.CITIZEN_STATUS_CODE == 'C'">US Citizen</span>
						<ul class="citizenship-country-list" v-else>
							<li v-if="form.form_data.customerValues.CITIZEN_COUNTRY_CODE">{{ form.form_data.customerValues.CITIZEN_COUNTRY_CODE }}</li>
							<li v-if="form.form_data.customerValues.CITIZEN_COUNTRY_CODE_2">{{ form.form_data.customerValues.CITIZEN_COUNTRY_CODE_2 }}</li>
							<li v-if="form.form_data.customerValues.CITIZEN_COUNTRY_CODE_3">{{ form.form_data.customerValues.CITIZEN_COUNTRY_CODE_3 }}</li>
						</ul>
					</div>
					<div><span>Social Security Number</span> <span>{{ form.form_data.customerValues.SSN }}</span></div>
					<div>
						<span>Transaction Purpose</span>
						<ul class="transaction-purpose-list"><li v-for="(purpose, index) in customerTransPurposeList" :key="index">{{ purpose }}</li></ul>
					</div>

					<div style="margin: 0 2em; border-bottom: 0 none;">
						<h3>NICS Response</h3><span></span>
						<label>NTN Number</label> <input type="text" v-model="form.nics_number">
						<label>FBI Status</label> <select v-model="form.form_data.section_b.nics_initial_response">
							<option value="">Select one...</option>
							<option value="Proceed">Proceed</option>
							<option value="Denied">Denied</option>
							<option value="Delayed">Delayed</option>
							<option value="Canceled">Canceled</option>
						</select>
						<label>Date</label> <input type="date" v-model="form.form_data.section_b.nics_initial_response_date_input">
					</div>
				</div>
				<div class="controls">
					<div class="button primary" @click="handleNicsPhoneCheck">OK</div>
					<div class="button primary" @click="nicsPhoneCheck = false">Cancel</div>
				</div>
			</div>
		</div>

	</div>

	<div class="transaction-purpose modal" v-else-if="nicsOnlineCheck && !(continueCheck && customerTransPurposeSet)">
		<div class="inner">
			<h2>Transaction Purpose</h2>
			<div class="content">
				<label><input type="checkbox" v-model="customerTransPurpose.l1">Handgun</label>
				<label><input type="checkbox" v-model="customerTransPurpose.l2">Long Gun</label>
				<label><input type="checkbox" v-model="customerTransPurpose.l3">Other Firearm</label>
				<label><input type="checkbox" v-model="customerTransPurpose.l4">Pre-pawn of hand gun</label>
				<label><input type="checkbox" v-model="customerTransPurpose.l5">Pre-pawn of long gun</label>
				<label><input type="checkbox" v-model="customerTransPurpose.l6">Pre-pawn of other</label>
				<label><input type="checkbox" v-model="customerTransPurpose.l7">Redemption of hand gun </label>
				<label><input type="checkbox" v-model="customerTransPurpose.l8">Redemption of long gun</label>
				<label><input type="checkbox" v-model="customerTransPurpose.l9">Redemption of other</label>
				<label><input type="checkbox" v-model="customerTransPurpose.l10">Private Sale hand gun</label>
				<label><input type="checkbox" v-model="customerTransPurpose.l11">Private Sale Long gun</label>
				<label><input type="checkbox" v-model="customerTransPurpose.l12">Private Sale Other</label>
				<label><input type="checkbox" v-model="customerTransPurpose.l13">Private Sale Returned to Seller Hand gun</label>
				<label><input type="checkbox" v-model="customerTransPurpose.l14">Private Sale Returned to Seller Long gun</label>
				<label><input type="checkbox" v-model="customerTransPurpose.l15">Private Sale Returned to Seller Other</label>
			</div>

			<div class="controls">
				<div v-if="customerTransPurposeSet" style="margin: 1em 0 0 0; display: grid; grid-template-columns: 3.25em 1fr; grid-column-gap: 1em;">
					<img src="@/assets/img/warning-icon.png" style="width: 3.25em;">
					<div style="text-align: left; line-height: 1.5em;">
						Click CONTINUE to open the FBI NICS website in a new window, then...<br>
						1) Log in using your LEEP username and password.<br>
						2) Click "Submit a Search Request - E.C."<br>
						3) Check "Yes" in the FFL Verification section.<br>
						4) Click "Revision Date May 2020" for the ATF Form Version.<br>
						5) Then, come <b>back to this window</b> to add info to the Search Request.
					</div>
				</div>
				<div class="cancel button" @click="nicsOnlineCheck = continueCheck = false">Cancel</div>
				<div class="primary button" @click="openNicsFrame()" v-if="customerTransPurposeSet">Continue</div>
				<div class="primary button disabled" v-else>Continue</div>
			</div>
		</div>
	</div>

	<div class="nics-online-check" v-if="nicsOnlineCheck">

		<h1>NICS Online Check</h1>

		<!-- <iframe :src="cjisIframeUrl" frameborder="0"></iframe> -->

		<div class="controls">

			<div style="margin: 1em 0 0 0; display: grid; grid-template-columns: 3.25em 1fr; grid-column-gap: 1em;">
				<img src="@/assets/img/warning-icon.png" style="width: 3.25em;">
				<div style="text-align: left; line-height: 1.5em;">
					On the FBI NICS page, did you...<br>
					1) Log in using your LEEP username and password?<br>
					2) Click "Submit a Search Request - E.C."?<br>
					3) Check "Yes" in the FFL Verification section?<br>
					4) Click "Revision Date May 2020" for the ATF Form Version?<br>
					If so, click the FILL THE FORM button to send info from this 4473 to the FBI NICS form.<br>
				</div>
			</div>

			<div class="button primary" @click="handleFillNicsForm()">Fill the Form</div>

			<div v-if="fillNicsFormChecked" style="margin: 1em 0; display: grid; grid-template-columns: 3.25em 1fr; grid-column-gap: 1em;">
				<img src="@/assets/img/warning-icon.png" style="width: 3.25em;">
				<div style="text-align: left; line-height: 1.5em;">
					Info from this 4473 should now be on the FBI NICS page.<br>
					Remember, you are soley responsible for the accuracy of your submission.<br>
					Please check all fields carefully before submitting your NICS check.<br>
					After submitting your NICS check, come <b>back to this window</b> where you should see the NTN Number and Initial Response.<br>
				</div>
			</div>

			<div class="nics-form-result" style="margin: 1em 0;">
				<label>NTN Number</label>
				<label>Initial Response</label>
				<input id="nics_number" type="text">
				<input id="nics_initial_response" type="text">
			</div>

			<div v-if="fillNicsFormChecked">
				Don't see the NTN Number and Initial Response? You can copy and paste them from the FBI NICS page.
			</div>

			<div class="button cancel" @click="nicsOnlineCheck = false; scrollToNTN()">Cancel</div>
			<div class="button primary" @click="saveOnlineNTNStatus">Continue</div>
		</div>
	</div>

	<div class="edit-warning modal" v-if="firearmEditWarning != null">
		<div class="inner">
			<h2>Confirm</h2>
			<div v-if="firearmEditComplete" class="content">
				<p>Cancel to leave this firearm entry unchanged, or Continue to authorize moving the oringal log book record to a new record with this new info.</p>
			</div>
			<div v-else class="content">
				<p>You are editing firearms information from your log books.</p>
				<p>In accordance with ATF regulations, this will create a new log book entry with your edited info. The original log book entry will be noted as moved.</p>
				<p>Cancel to leave this firearm entry unchanged, or Continue to finish making your changes to this firearm record.</p>
			</div>
			<div v-if="savingFirearmEdit" class="controls">
				Performing log book entry move
				<div v-html="savingFirearmEditMessage"></div>
			</div>
			<div v-else class="controls">
				<div class="cancel button" @click="revertFirearmEdit(firearmEditWarning)">Cancel</div>
				<div v-if="firearmEditComplete" class="primary warning button" @click="saveFirearmEdit(firearmEditWarning)">Continue</div>
				<div v-else class="primary warning button" @click="enableFirearmEdit(firearmEditWarning)">Continue</div>

			</div>
		</div>
	</div>

</div>

</template>

<script>
const BLANK_SECTION_B = {
	gun_show_name: null,
	gun_show_location: null,
	buyer_identification_issuing_authority_and_type: null,
	buyer_identification_type_code: null,
	buyer_identification_type_description: '',
	buyer_identification_number: null,
	buyer_identification_expiration_date: null,
	buyer_supplemental_government_documentation: null,
	nics_initial_response: null,
	nics_initial_response_date: null,
	nics_firearm_may_be_transferred: null,
	nics_later_response_proceed: null,
	nics_later_response_proceed_date: null,
	nics_later_response_denied: null,
	nics_later_response_denied_date: null,
	nics_later_response_canceled: null,
	nics_later_response_canceled_date: null,
	nics_later_response_no_response: null,
	nics_later_response_no_response_date: null,
	nics_later_response_overturned: null,
	nics_later_response_overturned_date: null,
	nics_after_transfer_response_date: null,
	nics_after_transfer_response: null,
	nics_examiner_name: null,
	nics_examiner_brady_number: null,
	employee_completing_nics: null,
	nics_buyer_background_check: null,
	nics_buyer_exempt_permit_date_issuance: null,
	nics_buyer_exempt_permit_date_expiration: null,
	nics_buyer_exempt_permit_number: null,
	customerTransPurpose: {
		l1: null,
		l2: null,
		l3: null,
		l4: null,
		l5: null,
		l6: null,
		l7: null,
		l8: null,
		l9: null,
		l10: null,
		l11: null,
		l12: null,
		l13: null,
		l14: null,
		l15: null
	}
}
const BLANK_SECTION_C = {
	buyer_recertification_signature: null,
	buyer_recertification_date: null,
}
const BLANK_SECTION_D = {
	firearms_list: [
		{ manufacturer: null, model: null, serial_number: null, gun_type: null, caliber: null }
	],
	total_firearms_transferred: null,
	transaction_pawn_redemption: null,
	transaction_pawn_redemption_line_numbers: null,
	seller_notes: null,
	private_party_transfer: null,
	seller_name_address_ffl: ''
}
const BLANK_SECTION_FINAL = {
	seller_name: null,
	seller_signature: null,
	seller_title: null,
	transfer_date: null,
	not_transferred: false
}
const TRANSACTION_PURPOSES = {
	l1: "Handgun",
	l2: "Long Gun",
	l3: "Other Firearm",
	l4: "Pre-pawn of hand gun",
	l5: "Pre-pawn of long gun",
	l6: "Pre-pawn of other",
	l7: "Redemption of hand gun ",
	l8: "Redemption of long gun",
	l9: "Redemption of other",
	l10: "Private Sale hand gun",
	l11: "Private Sale Long gun",
	l12: "Private Sale Other",
	l13: "Private Sale Returned to Seller Hand gun",
	l14: "Private Sale Returned to Seller Long gun",
	l15: "Private Sale Returned to Seller Other"
}
const CUSTOMER_RACE_CODES = {
	l4: "American Indian or Alaskan Native",
	l2: "Black or African American",
	l6: "White",
	l1: "Asian",
	l5: "Native Hawaiian or Other Pacific Islander"
}
const FIREARMS_LIST_FIREARM = { manufacturer: null, model: null, serial_number: null, gun_type: null, caliber: null }
export default {
	name: 'form4473-detail',
	props: ['id'],
	data() {
		return {
			form: {
				ffl_log_book_form_id: null,
				client_id: null,
				contact_id: null,
				date_created: null,
				nics_number: null,
				form_data: {
					first_name: null,
					address_1: null,
					address_2: null,
					birthdate: null,
					city: null,
					company_name: null,
					email_address: null,
					last_name: null,
					latitude: null,
					longitude: null,
					middle_name: null,
					phone_number: null,
					source_id: null,
					state: null,
					zip_code: null,
					country_code: null,
					deleted: null,
					actual_buyer: null,
					addict: null,
					alien_number: null,
					birth_city: null,
					convict: null,
					county: null,
					customerRace: {
						l1: null,
						l2: null,
						l4: null,
						l5: null,
						l6: null
					},
					customerValues: {
						CITIZEN_COUNTRY_CODE: null,
						CITIZEN_COUNTRY_CODE_2: null,
						CITIZEN_COUNTRY_CODE_3: null,
						CITIZEN_STATUS_CODE: null,
						DOB: null,
						EXC_CODE: null,
						FIRST_NAME: null,
						GENDER_CODE: null,
						HEIGHT: null,
						LAST_NAME: null,
						MIDDLE_NAME: null,
						MNU1: null,
						MNU_TYPE_CODE1: null,
						POB_CODE: null,
						SSN: null,
						STATE_CODE: null,
						UPIN: null,
						WEIGHT: null,
						isHispanicOrLatinofalse: null,
						isHispanicOrLatinotrue: null
					},
					section_b: {
						gun_show_name: null,
						gun_show_location: null,
						buyer_identification_issuing_authority_and_type: null,
						buyer_identification_type_code: null,
						buyer_identification_type_description: '',
						buyer_identification_number: null,
						buyer_identification_expiration_date: null,
						buyer_supplemental_government_documentation: null,
						nics_initial_response: null,
						nics_initial_response_date: null,
						nics_firearm_may_be_transferred: null,
						nics_later_response_proceed: null,
						nics_later_response_proceed_date: null,
						nics_later_response_denied: null,
						nics_later_response_denied_date: null,
						nics_later_response_canceled: null,
						nics_later_response_canceled_date: null,
						nics_later_response_no_response: null,
						nics_later_response_no_response_date: null,
						nics_later_response_overturned: null,
						nics_later_response_overturned_date: null,
						nics_after_transfer_response_date: null,
						nics_after_transfer_response: null,
						nics_examiner_name: null,
						nics_examiner_brady_number: null,
						employee_completing_nics: null,
						nics_buyer_background_check: null,
						nics_buyer_exempt_permit_date_issuance: null,
						nics_buyer_exempt_permit_date_expiration: null,
						nics_buyer_exempt_permit_number: null,
						customerTransPurpose: {
							l1: null,
							l2: null,
							l3: null,
							l4: null,
							l5: null,
							l6: null,
							l7: null,
							l8: null,
							l9: null,
							l10: null,
							l11: null,
							l12: null,
							l13: null,
							l14: null,
							l15: null
						}
					},
					section_c: null,
					section_d: null,
					section_final: null,
					dishonorable_discharge: null,
					domestic_violence: null,
					ethnicity: null,
					feet: null,
					first_initial: null,
					foreign_country: null,
					fugitive: null,
					i_certify: null,
					illegal_alien: null,
					inches: null,
					last_initial: null,
					legal_alien: null,
					mental: null,
					middle_initial: null,
					middle_name_blank: null,
					origin_country: null,
					other_country: null,
					picking_up_repaired: null,
					race: null,
					renounced_citizenship: null,
					restraining_order: null,
					signature: null,
					signed_date: null,
					under_indictment: null
				},
				inactive: null,
				internal_use_only: null,
				notes: null,
				status: null,
			},
			section_b: JSON.parse(JSON.stringify(BLANK_SECTION_B)),
			section_c: JSON.parse(JSON.stringify(BLANK_SECTION_C)),
			section_d: JSON.parse(JSON.stringify(BLANK_SECTION_D)),
			section_final: JSON.parse(JSON.stringify(BLANK_SECTION_FINAL)),
			nics_number: null,
			nics_buyer_background_check: null,
			nics_buyer_exempt: null,
			nics_buyer_exempt_permit_state_type: null,
			nics_status: null,
			nicsNumberSaved: false,
			leepUserName: "bill.duggin",
			leepPassword: "Karma1968",
			cjisIframeUrl: null,
			nicsPhoneCheck: false,
			nicsOnlineCheck: false,
			continueCheck: false,
			customerTransPurpose: {
				l1: false,
				l2: false,
				l3: false,
				l4: false,
				l5: false,
				l6: false,
				l7: false,
				l8: false,
				l9: false,
				l10: false,
				l11: false,
				l12: false,
				l13: false,
				l14: false,
				l15: false
			},
			serialNumberLookup: null,
			completeSections: {
				section_b: false,
				section_c: false,
				section_d: false,
				section_final: false
			},
			printing: null,
			savingSection: null,
			responseReceivedAfterTransfer: false,
			myOptions: {
				layout: {
					color: 'black',
					backgroundColor: 'lightgray',
					selectedColor: 'white',
					selectedBackgroundColor: 'green',
					borderColor: 'black',
					fontFamily: 'Arial',
					fontWeight: 'normal',
					fontWeightSelected: 'bold',
					squareCorners: false,
					noBorder: false
				},
				size: {
					fontSize: 14,
					height: 34,
					padding: 7,
					width: 100
				},
				items: {
					delay: .4,
					preSelected: 'unknown',
					disabled: false,
					labels: [
						{name: 'Off', color: 'white', backgroundColor: 'red'},
						{name: 'On', color: 'white', backgroundColor: 'green'}
					]
				}
			},
			firearmsIncomplete: [],
			firearmMessage: null,
			firearmMessageIndex: null,
			firearmEditIndex: null,
			firearmSearchResults: [],
			assignedFirearms: [],
			firearmEditWarning: null,
			firarmEditingIndex: null,
			firearmEditComplete: false,
			savingFirearmEdit: false,
			savingFirearmEditMessage: '',
			totalFirearmsTransferred: 'zero',
			onValue: "On",
			offValue: "Off",
			showHelp: [],
			sellerSignaturePad: null,
			prevPoint: null,
			scriptel: null,
			formNumberMessage: '',
			fillNicsFormChecked: false
		}
	},
	created() {
		if (this.id) {
			this.fetchData()
		}
	},
	mounted() {
		document.getElementById('logbooks').style['overflow-y'] = 'scroll'

	},
	computed: {
		today() {
			return this.$moment().format('YYYY-MM-DD')
		},
		readyForNICSCheck() {
			return (this.form.form_data.section_b.buyer_identification_issuing_authority_and_type && this.form.form_data.section_b.buyer_identification_type_code && this.form.form_data.section_b.buyer_identification_number)
		},
		sectionBValid() {
			// return this.form.nics_number || this.form.form_data.nics_buyer_background_check || (this.form.form_data.nics_buyer_exempt_permit_state_type && this.form.form_data.nics_buyer_exempt)
			return true
		},
		sectionBSaveEnabled() {
			return this.nics_number || this.form.nics_number || this.form.form_data.section_b.nics_buyer_background_check || (this.form.form_data.section_b.nics_buyer_exempt && this.form.form_data.section_b.nics_buyer_exempt_permit_state_type)
			// return true
		},
		sectionBComplete() {
			return this.completeSections.section_b
		},
		sectionCValid() {
			return this.section_c.buyer_recertification_signature && this.section_c.buyer_recertification_date
		},
		sectionCSaveEnabled() {
			// return this.nics_number || this.form.nics_number || this.nics_buyer_background_check || (this.nics_buyer_exempt_permit_state_type && this.nics_buyer_exempt)
			return true
		},
		sectionCComplete() {
			return this.completeSections.section_c
		},
		sectionDValid() {
			return this.form.form_data.section_d && this.form.form_data.section_d.firearms_list.length > 1 && this.form.form_data.section_d.seller_name_address_ffl
		},
		sectionDComplete() {
			// return this.form.form_data.section_d && this.form.form_data.section_d.firearms_list[0].serial_number
			// return this.completeSections.section_d
			// NOTE: can always update section D
			return false
		},
		sectionFinalValid() {
			if (document.location.hostname.indexOf('.test') > -1) {
				console.log('dev environment, signature not required')
				return this.section_final.seller_name && this.section_final.seller_title && (this.section_final.transfer_date || this.section_final.not_transferred)
			} else {
				return this.section_final.seller_name && this.section_final.seller_signature && this.section_final.seller_title && (this.section_final.transfer_date || this.section_final.not_transferred)
			}
		},
		sectionFinalComplete() {
			// return this.form.form_data.section_final && this.form.form_data.section_final.seller_name && this.form.form_data.section_final.seller_signature && this.form.form_data.section_final.seller_title && this.form.form_data.section_final.transfer_date
			// return this.completeSections.section_final
			return false
		},
		customerTransPurposeSet() {
			for (let prop in this.customerTransPurpose) {
				if (this.customerTransPurpose[prop]) return true
			}
			return false
		},
		customerRaceCodes() {
			let customerRaceCodes = []
			for (let race in this.form.form_data.customerRace) {
				if (this.form.form_data.customerRace[race]) {
					customerRaceCodes.push(CUSTOMER_RACE_CODES[race])
				}
			}
			return customerRaceCodes
		},
		customerTransPurposeList() {
			let customerTransPurposeList = []
			for (let prop in this.customerTransPurpose) {
				if (this.customerTransPurpose[prop]) {
					customerTransPurposeList.push(TRANSACTION_PURPOSES[prop])
				}
			}
			return customerTransPurposeList
		},
		laterResponseReceived() {
			return this.form.form_data && this.form.form_data.section_b && (this.form.form_data.section_b.nics_later_response_denied || this.form.form_data.section_b.nics_later_response_canceled || this.form.form_data.section_b.nics_later_response_no_response || this.form.form_data.section_b.nics_later_response_overturned)
		}
	},
	watch: {
		firearmMessage(newVal) {
			if (newVal) {
				setTimeout(() => {
					this.firearmMessageIndex = null
					this.firearmMessage = null
				}, 2000)
			}
		},
		"form.form_data.section_b.nics_initial_response"(newVal) {
			if (newVal == 'Delayed') {
				// delayed needs to add three weekdays to current date
				// https://gist.github.com/psdtohtml5/7000529
				var addDays = 3
				var today = new Date()
			    var d = new Date(today.getTime())
			    var day = d.getDay()
			    d.setDate(d.getDate() + addDays + (day === 6 ? 2 : +!day) + (Math.floor((addDays - 1 + (day % 6 || 1)) / 5) * 2))
				console.log(d)
				this.form.form_data.section_b.nics_firearm_may_be_transferred = this.$moment(d).format('YYYY-MM-DD');
				//this.form.form_data.section_b.nics_firearm_may_be_transferred = this.$moment().add(3, "days").format("YYYY-MM-DD")
			}
		}
	},
	methods: {
		fetchData() {
			this.apiCall({ destination: 'get_item_ffl_log_book_form', data: { ffl_log_book_form_id: this.id, version: 1 } }).then(obj => {
				if (obj.status == 'success') {
					this.form = obj.log_book_form
					if (this.form.form_data.section_b) {
						this.completeSections.section_b = (obj.log_book_form.status_codes.FINAL_COMPLETE) ? true : false
					} else {
						this.form.form_data.section_b = JSON.parse(JSON.stringify(BLANK_SECTION_B))
					}
					if (this.form.form_data.section_c) {
						this.completeSections.section_c = (obj.log_book_form.status_codes.C_COMPLETE) ? true : false
					} else {
						this.form.form_data.section_c = JSON.parse(JSON.stringify(BLANK_SECTION_C))
					}
					if (this.form.form_data.section_d) {
						this.checkFirearmsList()
					} else {
						this.form.form_data.section_d = JSON.parse(JSON.stringify(BLANK_SECTION_D))
						this.checkFirearmsList()
					}
					if (this.form.form_data.section_final) {
						this.form.form_data.section_final = this.section_final = obj.log_book_form.form_data.section_final
						this.completeSections.section_final = (obj.log_book_form.status_codes.FINAL_COMPLETE) ? true : false
					} else {
						this.form.form_data.section_final = JSON.parse(JSON.stringify(BLANK_SECTION_FINAL))
					}
					if (!this.form.form_data.section_final.seller_signature) {
						setTimeout(() => {
							this.initializeSellerSignaturePad()
						}, 500)
					}
				}
			}).catch(err => {
				console.log(err)
			})
		},
		handleNicsPhoneCheck() {
			this.saveSectionB()
			this.nicsPhoneCheck = false
		},
		openNicsFrame() {
			this.continueCheck = true
			//this.cjisIframeUrl = "https://www.cjis.gov/"
			window.open("https://www.cjis.gov/")
		},
		handleFillNicsForm() {
			let formInfo = {
				customerValues: {},
				customerRace: {},
				customerTransPurpose: {}
			}

			this.form.form_data.customerValues.MNU1 = this.form.form_data.customerValues.MNU1.replace(/-/gi, '')
			this.form.form_data.section_b.buyer_identification_number = this.form.form_data.section_b.buyer_identification_number.replace(/-/gi, '')

			formInfo.customerValues = this.$copy(this.form.form_data.customerValues)
			formInfo.customerRace = this.$copy(this.form.form_data.customerRace)
			formInfo.customerTransPurpose = this.customerTransPurpose

			if (this.form.form_data.customerValues.CITIZEN_STATUS_CODE == 'C') {
				formInfo.customerValues.MNU1 = this.form.form_data.section_b.buyer_identification_number
				formInfo.customerValues.MNU_TYPE_CODE1 = this.form.form_data.section_b.buyer_identification_type_code
			}
			window.formInfo = formInfo
			var event = new CustomEvent('fill_form', { detail: formInfo });
			window.dispatchEvent(event);
			this.fillNicsFormChecked = true;
		},
		handleStatusUpdate() {
			chrome.runtime.sendMessage(editorExtensionId, { message: 'status_update', nics_number: this.form.nics_number }, function(response) {
				if (response.success) {
					this.cjisIframeUrl = "https://www.cjis.gov/"
				}
			})
		},
		saveFormNumber() {
			this.apiCall({ destination: 'save_4473_form_number', data: { ffl_log_book_form_id: this.id, form_number: this.form.form_number, version: 1 } }).then(obj => {
				if (obj.status == 'success') {
					this.formNumberMessage = 'Form number saved!'
				} else {
					this.formNumberMessage = obj.message
				}
			}).catch(err => {
				console.log(err)
			})
		},
		saveOnlineNTNStatus() {
			this.form.nics_number = nics_number.value
			this.form.form_data.section_b.nics_initial_response = nics_initial_response.value
			this.form.form_data.section_b.nics_initial_response_date = this.$moment().format('YYYY-MM-DD')
			this.nicsOnlineCheck = false
			this.scrollToNTN()
		},

		// Seller Signature Pad Methods
		initializeSellerSignaturePad() {
			//Get the canvas element from the document.
			this.sellerSignaturePad = document.getElementById('seller_signature_pad');

			//Create a new ScriptelEasyScript handler
			this.scriptel = new ScriptelEasyScript();

			//If we're using international keyboard support this callback
			//looks for the starting character as typed by different keyboards
			//in an attempt to automatically detect which keyboard we're using.
			//
			//This is only provided as an example, depending on your use
			//case something more robust will probably be required.
			//
			//Note: This is only for non-streaming, non-compressed EasyScript
			//devices, in these modes this is handled automatically.
			this.scriptel.configurationCallback = (evt,chr) => {
				if(chr==='"') {
					this.scriptel.fromKeyboardSpec = "ca-fr";
				} else {
					this.scriptel.fromKeyboardSpec = "us-basic";
				}
			};

			//Adds a signature listener to the document that will automatically catch
			//any signatures "typed" within the document body.
			//
			//WARNING!!!!!
            //If you are creating pop-up window (modal) and
            //are registering the listener to document make sure you
            //call removeSignatureListener when the modal is
            //destroyed otherwise the library will continue listening.
			this.scriptel.addSignatureListener(document);

			//Adds a streaming callback to the EasyScript library,
			//this gets notified when events happen.
			this.scriptel.registerStreamingCallback((e) => {
		        switch (e.type) {
		            case "ScriptelSignatureMetaData":
						this.clearSellerCanvas();
		                break;
		            case "ScriptelNewStroke":
                		this.prevPoint = null;
		                break;
		            case "ScriptelCoordinate":
		            	if (this.prevPoint != null) {
							this.scriptel.drawSegmentOnCanvas(this.prevPoint, e, this.sellerSignaturePad,{"strokeStyle":"black","lineWidth":2});
						}
						this.prevPoint = e;
		                break;
		            case "ScriptelCancelSignature":
		            	this.clearSellerCanvas();
		            	this.prevPoint = null;
		                break;
		            case "ScriptelSignatureComplete":
		            	this.saveSellerSignature()
		                break;
		        }
			})

            this.clearSellerCanvas()
		},
		saveSellerSignature() {
	        this.form.form_data.section_final.seller_signature = this.sellerSignaturePad.toDataURL()
	        this.prevPoint = null
		},
		clearSellerCanvas() {
            //Get the graphics context of the canvas.
            var ctx = this.sellerSignaturePad.getContext("2d");
            //Set the fill
            ctx.fillStyle = "transparent";
            //Clear the canvas and fill with the background color:
            ctx.clearRect(0,0,this.sellerSignaturePad.width,this.sellerSignaturePad.height);
        },
        cancelSellerSignature() {
        	this.form.form_data.section_final.seller_signature = null
        	setTimeout(() => {
        		this.initializeSellerSignaturePad()
        	}, 500)
        },
		toggleNotTransferred() {
			this.section_final.not_transferred = !this.section_final.not_transferred
			if (this.section_final.not_transferred) {
				this.section_final.transfer_date = ''
				this.form.form_data.section_d.total_firearms_transferred = "zero"
			} else {
				this.checkFirearmsList()
			}
		},
		saveSection(sectionName) {
			this.savingSection = sectionName
			this.apiCall({ destination: 'save_4473_section', data: { ffl_log_book_form_id: this.id, section_name: sectionName, form: this.form, version: 1 } }).then(obj => {
				if (obj.status == 'success') {
					if (sectionName == 'section_b') {
						// these dates are generated by the API and used to prevent double log entries
						if (obj.form_data.section_b.nics_initial_response_date) {
							this.form.form_data.section_b.nics_initial_response_date_date = obj.form_data.section_b.nics_initial_response_date.substring(0,10)
						}
						this.form.form_data.section_b.nics_later_response_proceed_date = obj.form_data.section_b.nics_later_response_proceed_date
						this.form.form_data.section_b.nics_later_response_denied_date = obj.form_data.section_b.nics_later_response_denied_date
						this.form.form_data.section_b.nics_later_response_canceled_date = obj.form_data.section_b.nics_later_response_canceled_date
						this.form.form_data.section_b.nics_later_response_no_response_date = obj.form_data.section_b.nics_later_response_no_response_date
						this.form.form_data.section_b.nics_later_response_overturned_date = obj.form_data.section_b.nics_later_response_overturned_date
						this.form.form_data.section_b.nics_after_transfer_response_date = obj.form_data.section_b.nics_after_transfer_response_date
					}
					if (sectionName == 'section_c') {
						this.completeSections['section_c'] = true
					}
					if (sectionName == 'section_final') {
						this.completeSections.section_b = true
						this.completeSections.section_d = true
						this.completeSections.section_final = true
					}
				}
				this.savingSection = null
			}).catch(err => {
				console.log(err)
				this.savingSection = null
			})
		},
		saveSectionB() {
			this.saveSection('section_b')
		},
		saveSectionC() {
			this.form.form_data.section_c = this.section_c
			this.saveSection('section_c')
		},
		saveSectionD() {
			var complete
			this.form.form_data.section_d.firearms_list.forEach((firearm, index) => {
				complete = this.firearmComplete(firearm)
				if (complete.length != 5) {
					this.form.form_data.section_d.firearms_list.splice(index, 1)
				}
			})
			this.firearmsIncomplete = []
			this.saveSection('section_d')
		},
		saveSectionFinal() {
			this.form.form_data.section_final = this.section_final
			this.saveSection('section_final')
		},
		toggleHelp() {
			this.showHelp = !this.showHelp
		},
		backToList() {
			this.$router.push('/4473')
		},
		scrollToNTN() {
			console.log(this.$refs)
			var interval = setInterval(() => {
				if (this.$refs.form_nics_number) {
					clearInterval(interval)
					var rect = this.$refs.form_nics_number.getBoundingClientRect()
					var scrollTop = window.pageYOffset || document.documentElement.scrollTop
				    var top = rect.top + scrollTop - 100 // 100 is just a buffer to give a bit of padding on top
				    window.scroll({ top: top, left: 0, behavior: "smooth"})
				}
			}, 10)
		},
		serialSearch(index, serialNumber) {
			if (!serialNumber) return
			this.serialNumberLookup = index
			let excludeFromSearch = []
			for (var i = 0; i < this.form.form_data.section_d.firearms_list.length; i++) {
				if (this.form.form_data.section_d.firearms_list[i].serial_number != serialNumber) {
					excludeFromSearch.push(this.form.form_data.section_d.firearms_list[i].serial_number)
				}
			}
			this.apiCall({ destination: 'serial_number_lookup', data: { on_hand: 1, search_term: serialNumber, exclude: excludeFromSearch }}).then(obj => {
				if (obj.status == 'error') {
					this.firearmMessage = 'Serial number not found, please try again.'
					this.firearmMessageIndex = index
					this.serialNumberLookup = null
				} else if (obj.firearms_list.length > 1) {
					// display list to select from
					this.firearmSearchResults = obj.firearms_list
				} else if (obj.firearms_list.length == 1) {
					this.assignFirearmsList(index,obj.firearms_list[0])
					this.checkFirearmsList()
					this.serialNumberLookup = null
				} else {
					this.firearmMessage = 'Serial number not found, please try again.'
					this.firearmMessageIndex = index
					this.serialNumberLookup = null
				}
			}).catch(err => {
				console.log(err)
				this.serialNumberLookup = null
			})
		},
		cancelSerialNumberSearchResults() {
			this.serialNumberLookup = null
			this.firearmSearchResults = []
			this.firearmMessage = ''
			this.form.form_data.section_d.firearms_list[this.form.form_data.section_d.firearms_list.length - 1]['serial_number'] = ''
		},
		assignFirearmsList(index,assignObject) {
			this.serialNumberLookup = null
			this.form.form_data.section_d.firearms_list[index].ffl_log_book_entry_id = assignObject.ffl_log_book_entry_id
			this.form.form_data.section_d.firearms_list[index].manufacturer = assignObject.manufacturer
			this.form.form_data.section_d.firearms_list[index].model = assignObject.model
			this.form.form_data.section_d.firearms_list[index].serial_number = assignObject.serial_number
			this.form.form_data.section_d.firearms_list[index].gun_type = assignObject.gun_type
			this.form.form_data.section_d.firearms_list[index].caliber = assignObject.caliber

			// we'll use this to compare if user changes any value in a firearm row
			this.assignedFirearms[index] = assignObject

			this.firearmSearchResults = []
			this.firearmMessage = ''
			this.checkFirearmsList()
		},
		revertFirearmEdit(index) {
			for (let prop in this.form.form_data.section_d.firearms_list[index]) {
				this.form.form_data.section_d.firearms_list[index][prop] = this.assignedFirearms[index][prop]
			}
			this.firearmEditWarning = null
			this.firarmEditingIndex = null
			this.firearmEditComplete = false
		},
		enableFirearmEdit(index) {
			this.firarmEditingIndex = index
			this.firearmEditWarning = null
			this.firearmEditComplete = false
		},
		confirmFirearmEdit(index) {
			this.firearmEditWarning = index
			this.firearmEditComplete = true
		},
		saveFirearmEdit(index) {
			// this.assignedFirearms[index] will have the original ffl_log_book_entry_id
			// TODO: make API call(s) to move the original record and create a new record that merges this data
			this.savingFirearmEdit = true
			this.savingFirearmEditMessage = "<i class='far fa-compass fa-spin'></i>"
			this.assignedFirearms[index]['incomplete'] = true // will trigger API to acquire complete data set for moving
			this.apiCall({ destination: 'save_item_ffl_log_book_entry_move', data: { entry: this.assignedFirearms[index], merge: this.form.form_data.section_d.firearms_list[index] } }).then(obj => {
				this.savingFirearmEditMessage = obj.message
				if (obj.status == 'success') {
					this.assignedFirearms[index]['ffl_log_book_entry_id'] = obj.moved_to_ffl_log_book_entry_id
					var timer = setTimeout((function() {
						this.savingFirearmEdit = false
						this.firearmEditWarning = null
						this.firarmEditingIndex = null
						this.firearmEditComplete = false
					}.bind(this)),2000)
				}
			}).catch(err => {
				console.log(err)
			})

		},
		generatePDFLink() {
			//return this.getApiEndpoint + '?action=form_4473_pdf&source=logbooks&form_id=' + this.$randomString(6) + this.id + this.$randomString(6) + this.form.client_id + this.$randomString(6)
			return this.getApiEndpoint + '?action=form_4473_pdf&source=logbooks&fd_token=' + getCookie('dashboard_token') + '&form_id=' + this.$randomString(6) + this.id + this.$randomString(6)
		},
		checkFirearmsList(index) {
			var count = 0
			var complete
			this.form.form_data.section_d.firearms_list.forEach((firearm, index) => {
				// if we're not already editing a row, has user changed anything?
				if (this.firarmEditingIndex == null && this.assignedFirearms[index]) {
					for (let prop in firearm) {
						if (firearm[prop] != this.assignedFirearms[index][prop]) {
							this.firearmEditWarning = index
							return false
						}
					}
				}
				complete = this.firearmComplete(firearm)
				if (complete.length == 5) {
					count++
					var pos = this.firearmsIncomplete.findIndex((element) => {
						return element == index
					})
					if (pos > -1) {
						this.firearmsIncomplete.splice(pos, 1)
					}
				} else {
					if ((index < this.form.form_data.section_d.firearms_list.length - 1) && !this.firearmsIncomplete.includes(index)) {
						this.firearmsIncomplete.push(index)
					}
				}
			})
			if (complete.length == 5) {
				this.form.form_data.section_d.firearms_list.push({ manufacturer: null, model: null, serial_number: null, gun_type: null, caliber: null })
			}
			this.form.form_data.section_d.total_firearms_transferred = this.$toWords(count)
		},
		firearmComplete(firearm) {
			var complete = []
			for (let prop in firearm) {
				// ignore ffl_log_book_entry_id, track which inputs have values
				if (prop != 'ffl_log_book_entry_id' && firearm[prop]) {
					complete.push(prop)
				}
			}
			return complete
		},
		toggleHelp(index) {
			if (this.showHelp.indexOf(index) > -1) {
				this.showHelp.splice(this.showHelp.indexOf(index), 1)
			} else {
				this.showHelp.push(index)
			}
		}
	}
}
</script>

<style lang="scss" scoped>
#detail-4473-legacy {
iframe {
    width: 92vw;
    height: 640px;
}
span.exc-code-na {
    float: right;
    margin: 0 10px;

    i {
    	margin-right: 10px;
    }
}
.home-address {
    margin-top: 1em;
}
.form {
	position: relative;
	display: grid;
	grid-template-columns: repeat(5, 1fr);

	&.show-help {
		// grid-template-columns: repeat(6, 1fr);
	}

	h2.section-title {
		grid-column-start: 1;
	    grid-column-end: all;
	    text-align: center;
	    border: solid;
	    border-width: 1px 0 0 0;
	    margin: 1em 0 0 0;
	    font-size: 1.3em;
	    font-weight: 600;

	    &.left { text-align: left; }

	    &:first-child {
	    	border-width: 0 0 1px 0;
	    }
	}

	.dark-font {
		font-weight: bold;
		margin-bottom: 0.5em;
		font-size: 0.9em;
	}

	.controls {
	    grid-column: span 6;
	    text-align: right;
	    padding: 1em 0 1em 0;
	    margin: 0;
	    border-top: 1px solid black;
	    .fa-spinner, .error {
		    justify-self: left;
		}

		a.button { /* height: 1em; */ margin-right: 0.5em; }
		.button { margin-right: 0.5em; }
		.error { color: red; }
	    &.section-top {
		    border-top: 0 none;
		}
		&.nics-check {
		    grid-template-columns: max-content max-content;
		}
	    &.section-final {
		    grid-template-columns: max-content max-content max-content 26px;
		}
	}

	.form-line {
		position: relative;
		grid-column: span 5;
		display: grid;
		border-top: 1px solid;
		margin: 1em 0;
	    padding-top: 1em;
	    grid-gap: 0.8em;
	    grid-template-columns: repeat(6, 1fr);
	    align-items: start;

		&.grid-four {
	    	grid-template-columns: repeat(4, 1fr);
	    	div {
	    		grid-column: span 1;
	    	}
	    	div.form-half {
			    grid-column: span 2;
			}
			input.form-half {
				grid-column: span 2;
				width: 30%;
			}
	    }

	    &.grid-five {
	    	grid-template-columns: repeat(5, 1fr);
	    	div {
	    		grid-column: span 1;
	    	}
	    }

		&:first-of-type {
			border-width: 0 0 1px 0;
		    // padding-top: 0;
		}

		div {
		    grid-column: span 5;

		    label { margin-right: 1rem; }

		    &.label + div { grid-column: span 1; }

		    &.form-full, &.form-half {
				margin: 0;
			}
			&.form-full {
			    grid-column-start: 1;
			    grid-column-end: all;
			}
			&.form-full label {
				display: inline-block;
			}
			&.form-half {
				grid-column: span 3;
			}
			&.form-third {
				grid-column: span 2;
			}
			&.span-1 { grid-column: span 1; padding: 0 1em 0 0; }
			&.span-2 { grid-column: span 2; padding: 0 1em 0 0; }
			&.line-break {
			    grid-column-start: 1;
			}

			label + input + select { margin: 0.5em 0; }
			label + select {
			    min-width: 3em;
			    width: 96%;
			}
		}

		textarea.dealer-address {
		    min-height: 7em;
		}

		i.far {
		    margin-right: 10px;
		}

		&.certification { border: none; }

		.button {
		    grid-column: 1 / 2;
		    margin-top: 1em;
		    max-width: 60%;
		}

		.date-label input[type="date"] {
		    // min-height: 2em;
		    // font-size: 1em;
		    margin-right: 1em;
		}
	}

	.checkbox i.far {
	    margin-right: 10px;
	}
	.off-value, .on-value {
		margin: 0;
	}
	label.checkbox { display: inline-block !important;}

	#race {
		border-left: 1px solid;
		padding-left: 1em;
		div.checkbox {
			display: inline-block;
			min-width: 21em;
		}
	}

	table {
		grid-column-start: 1;
		grid-column-end: all;
		tr {
			position: relative;
			display: block;
		}
		th, td {
			text-align: center;
			font-weight: normal;
			width: 3vw;
			border-right: 1px solid;
			padding: 0.5em 0;
			border-bottom: 1px solid;
			table td { border: none; }
		}
		tr.incomplete td {
			border-bottom: 1px solid red !important;
			border-top: 1px solid red !important;

			&:first-child {
				border-left: 1px solid red;
			}
			&:last-child{
				border-right: 1px solid red;
			}
		}
		th, td {
			&:first-of-type {
				width: 94vw !important;
				text-align: left;
			}
		}
		td {
			&.citizenship, &.mnu { width: 100vw !important; }
		}
		div.checkbox {
			display: inline-block;
			min-width: 21em;
		}
		td.help-box {
			font-weight: bold;
		}
		i.fas.fa-search {
			cursor: pointer;
			margin-left: 0.5em;
		}
	}

	label { display: block; }

	.line-break {
	    grid-column-start: 1;
	}

	.question-label {
		font-size: 1.3em;
	}

	table.firearms-list {
		label {
			display: inline-block;
			margin-right: 1em;
		}
		input { width: 75%; }
		tr {
			td, th {
				padding: 10px;
				width: 20%;
				border: solid;
			}
			th {
				border-width: 2px 0 2px 2px;
				&:last-child {
					border-right-width: 2px;
				}
			}
			td {
				border-width: 1px 0 1px 1px;
				&:last-child {
					border-right-width: 1px;
				}
			}
		}

		.loading, .firearm-lookup-message, .firearm-edit-message {
			display: initial;
			width: calc(100% - 2px);
		    height: calc(100% - 2px);
		    font-size: 1.5em;
		    padding: 0.5em 0;
		}
		.firearm-lookup-message, .firearm-edit-message {
			display: block;
		    position: absolute;
			z-index: 1000;
		    top: 0;
		    left: 1px;
		    background: rgba(255, 255, 255, 0.8);
		    font-size: 1.2em;
		    padding-top: 0.8em;
			.search-list {
				background-color: #fff;
				border: 1px solid #ddd;
				font-size: 0.85em;
				margin-bottom: 0.5em;
				line-height: 1em;
				width: 33em;
				margin: 0 auto;
				text-align: left;
				li {
					display: grid;
				    grid-template-columns: 1fr 1.5fr;
				    padding: 0.25em 0.5em;
				}
			}
		}

		.firearm-edit-message {
		    top: 3.66em;
		}
	}

	.signature { max-height: 5em; max-width: 30em; }
}
.transaction-purpose.modal {
	.inner {
		max-width: 100%;
	    min-width: 25em;
		.content {
			column-count: 2;
		}
	}
	label {
		display: block;
		font-size: 1em;
	    padding-bottom: 0.5em;
	}
	input[type="checkbox"] {
	    margin-right: 0.7em;
	}
}
.nics-phone-check .inner {
    min-width: 600px;
    max-height: 70%;
    overflow: hidden;
    position: relative;
    display: grid;
    grid-template-rows: 12fr 1fr;
    width: 30%;
    padding: 0;

    .content {
    	overflow: scroll;
    	display: initial;
	    width: 100%;
        max-height: initial;
	    border-bottom: 0;
	    padding: 2em;
    }
    div {
	    display: grid;
	    grid-template-columns: 1.1fr 2fr;
	    border-bottom: 1px solid;
	    padding: 0.6em 0;
	    align-items: center;

	    &.small {
	    	display: block;
	    	font-size: 0.8em;
	    	border-bottom: 0 none;
	    }

	    &.button {
	    	text-align: center;
		    grid-template-columns: 1fr;
		    max-width: 150px;
		    width: 60%;
	    }
	    &.button:first-child {
	    	justify-self: right;
	    }
    }
    .controls {
	    width: 100%;
	    background: white;
	    height: 5em;
	    box-sizing: border-box;
	    margin: 0;
	    padding: 1em;
	    display: grid;
	    grid-template-columns: 1fr 1fr;
	    grid-column-gap: 1em;
	    border: solid;
	    border-width: 1px 0 0 0;
	}
}
.customer-race-list, .transaction-purpose-list, .citizenship-country-list {
	list-style-type: none;
	li {
		display: inline-block;
		margin-right: 3px;

		&:after {
			content: ","
		}
		&:last-child {
			margin-right: 0;
		}
		&:last-child:after {
			content: ""
		}
	}
}
.cancel.button {
    background: none;
    color: #4e4e4e;
}
.nics-online-check .controls {
    width: 70%;
    text-align: center;
    margin: 0 auto;
	.note { font-size: 0.8em; }
	.fill-the-nics-form {
		margin: 1em 0;
		display: grid;
		grid-template-columns: 1fr 10em;
		grid-gap: 1em;
		text-align: left;
	}
	.nics-form-result {
		margin: 0 0 1em 0;
		display: grid;
		grid-template-columns: 1fr 1fr;
		grid-column-gap: 1em;
		text-align: left;
		label {
			text-align: left;
			margin-bottom: 0;
		}
	}
}
.transaction-purpose.modal {
	.controls {
		width: 100%;
	}
}

.help-box-outer {
	position: relative;
}
.help-box {
    padding: 1.6em 1em 1em 1em;
    margin: 1em 0 1em 0;
    font-size: 0.9em;
    font-weight: bold;
    z-index: 2;
    justify-self: start;
    color: #737375;
    background: #f4f4f4;
}
.help-box-label {
	float: right;
    margin: -0.75em 0 0 0;
    padding: 4px;
    background: #999;
    color: white;
    cursor: pointer;
}
.help-box-label:hover {
    opacity: 0.9;
}
.help-box-label-live {
    background: #b70000;
}

.help-box p {
    margin-bottom: 0.5em;
}
.help-box p:last-child {
    margin-bottom: 0;
}
.help-toggle {
	position: fixed;
    font-size: 0.8em;
    left: calc(100vw - 75px);
    bottom: 5em;
    cursor: pointer;
    text-transform: uppercase;
    transform: rotate(90deg);
    color: white;
    background: #bbb;
    padding: 0.5em 1em;
}
.help-toggle:hover {
	background: #aaa;
}
.help-toggle.active {
	background-color: #b70000;
}
}
</style>
